/**
 * Created by hzzhao
 */

import * as baseElementLogics from '../elements/components/BaseElement/logics';
import * as constants from '../utils/constants';
import * as elementActions from '../elements/actions';
import * as elementLogics from '../elements/logics';
import * as mainActions from '../main/actions';
import * as mainSelectors from '../main/selectors';
import * as textActions from './actions';
import * as textSelectors from './selectors';
import * as utils from '../utils';

import {
  TOO_LONG_TEXT_ENTERED_MESSAGE,
  TOO_MANY_LINES_ENTERED_MESSAGE,
  defaultDigitalTextColor,
  outlineThicknessList,
  textStyleIconStatus,
} from './constants';
import {
  addNewElementForText,
  adjustImageSizeToFitContainer,
  getImageLayerIndex,
  getRectPoints,
  rotateText,
} from '../canvas/logics';
import { addRecentlyUsedColor, setFreeColor } from '../nextgen/actions';
import {
  changeFontStyle,
  copyTextElement,
  selectText,
  setImageListByImprintAreaKeyAction,
  setTextListByImprintAreaKeyAction,
  unSelectAllText,
} from '../canvas/actions';
import {
  changeStyleToAllUpsellText,
  changeUpsellFontCode,
  changeUpsellFontFace,
  changeUpsellFontSizesAndUpsellImprintFits,
  changeUpsellHeightFits,
  changeUpsellImprintAreaDimension,
  changeUpsellScale,
  changeUpsellText,
  changeUpsellTextStyle,
} from '../upsell/actions';
import { configuratorAction, studioItemType } from '../main/constants';
import { getBackupTextColor, getFreeColor } from '../nextgen/selectors';
import {
  getBatchSelectedTextList,
  getCanvasDraggingArea,
  getCanvasImageList,
  getCanvasScale,
  getCurrentCanvasData,
  getCurrentScaleFactor,
  getCurrentStudioScale,
  getStudioScaleByKey,
} from '../canvas/selectors';
import { getChildItemIdFromBomSelectionForLite, getIsLiteParentChildItem } from '../lite/selectors';
import {
  getCurrentUpsellFontList,
  getCurrentUpsellImprintAreaKey,
  getCurrentUpsellTextDataDict,
  getCurrentUpsellTextDataList,
  getCurrentUpsellTextList,
} from '../upsell/selectors';
import { getDebossCheck, getHotStampedCheck } from '../imprintarea/logics';
import {
  getImprintColors,
  getImprintFormatDetail,
  getImprintOptionType,
  getMultipleImageColorsTopToMaxCheck,
  getSelectedImprintAreaKeys,
} from '../imprintarea/selectors';
import { getImprintSizing, getTextElement } from '../text/apis';
import { getScreenMode, offsetNewRecentArtOrText } from '../nextgen/logics';
import { initUndoRedoList, pushToUndoList, updateUndoListRecord } from '../canvas/components/UndoRedo/logic';
import { selectUpsellText, unSelectAllUpsellText } from '../upsell/actions';
import { updateFullPreview, updateUpsellFullPreview } from '../preview/logics';

import { TemplateType } from '../template/constants';
import { changeArtColor } from '../canvas/actions';
import { changeLogoColor } from '../uploadimage/logics';
import { changeNextgenUiStatus } from '../nextgen/actions';
import { checkImprintColorEmpty } from '../templateeditor/logics';
import { getAllColorsInUse } from '../userimage/selectors';
import { getBackupTextOutlineColor } from '../nextgen/selectors';
import { getColorChangeElements } from '../elements/selectors';
import { getConfiguratorAction } from '../main/logics';
import { getCurrentUpsellItemId } from '../main/selectors';
import { getDefaultText } from './selectors';
import { getHotStampColorImageUrl } from '../utils/scene7url';
import { getImprintOptionMaxColorCount } from '../imprintarea/selectors';
import { getIsNextGenUI } from '../nextgen/selectors';
import { getRotatedRectPoints } from '../nextgen/canvas/logic';
import { getSelectedTemplate } from '../template/selectors';
import { getSingleSelectedElement } from '../nextgen/main/MainPanel/selectors';
import { getTextElementForAdminTool } from '../templateeditor/apis';
import { getVendorId } from '../main/selectors';
import { hideWaitingCover } from '../main/actions';
import { nextGenFlyoutPanelEnum } from '../nextgen/constants';
import { nextgenScreenMode } from '../nextgen/constants';
import { rotateCanvasElement } from '../nextgen/canvas/logic';
import { setBackupElementsAction } from '../nextgen/actions';
import { setBackupTextColor } from '../nextgen/actions';
import { setBackupTextOutlineColor } from '../nextgen/actions';
import { setIsEditingText } from '../canvas/actions';
import { setMaxAvailableFontSize } from '../canvas/actions';
import { showWaitingCover } from '../main/actions';
import { studioItemType as studioItemTypeEnum } from '../main/constants';
import { textMode } from '../utils/constants';
import { userImageType } from '../utils/constants';
import { v4 as uuidv4 } from 'uuid';

//private BEGIN
/** check if the style to change is available
 * @param  {Object} fontList - font list for current imprint area code
 * @param  {enum} styleToChange - constants.textStyleType
 * @param  {Object} currentStyleObj - current text style: { isBold, isItalic, isUnderline }
 * @returns {Boolean} - check result
 */
const checkStyleAvailable = function (fontList, styleToChange, currentStyleObj) {
  const fontFaceList = [];
  fontList.forEach((font) => {
    if (font.fontFace === currentStyleObj.fontFace) {
      fontFaceList.push(font);
    }
  });
  let hasBTrueITrue = fontFaceList.some((font) => font.hasBold === true && font.hasItalic === true);
  let hasBTrueIFalse = fontFaceList.some((font) => font.hasBold === true && font.hasItalic === false);
  let hasBFalseITrue = fontFaceList.some((font) => font.hasBold === false && font.hasItalic === true);
  let hasBFalseIFalse = fontFaceList.some((font) => font.hasBold === false && font.hasItalic === false);
  if (styleToChange === constants.textStyleType.Bold) {
    if (fontFaceList.length === 2) {
      if (hasBFalseIFalse && hasBTrueITrue) {
        // isBold has not taken the opposite. isBold and isItalic have the same value
        currentStyleObj.isItalic = !currentStyleObj.isBold;
      } else if (hasBTrueIFalse && hasBFalseITrue) {
        currentStyleObj.isItalic = currentStyleObj.isBold;
      }
    } else if (
      !fontFaceList.some((f) => f.hasBold === !currentStyleObj.isBold && f.hasItalic === currentStyleObj.isItalic)
    ) {
      currentStyleObj.isAvailableStyle = false;
    }
  } else if (styleToChange === constants.textStyleType.Italic) {
    if (fontFaceList.length === 2) {
      if (hasBFalseIFalse && hasBTrueITrue) {
        currentStyleObj.isBold = !currentStyleObj.isItalic;
      } else if (hasBTrueIFalse && hasBFalseITrue) {
        currentStyleObj.isBold = currentStyleObj.isItalic;
      }
    } else if (
      !fontFaceList.some((f) => f.hasBold === currentStyleObj.isBold && f.hasItalic === !currentStyleObj.isItalic)
    ) {
      currentStyleObj.isAvailableStyle = false;
    }
  }
  return currentStyleObj;
};

export const calculateMaxAvailableFontSize = (props) => (dispatch, getState) => {
  const { guid, imprintAreaKey } = props;
  const state = getState();
  let draggingArea = getCanvasDraggingArea(state);
  const textElement = elementLogics.getElement(state.textDict, imprintAreaKey, guid);
  if (textElement) {
    let tempElement = { ...textElement };
    let fontSizeRange = textSelectors.getFontSizeRange(state);
    const maxFontSizeAvailable = checkFontSizeAvailable(fontSizeRange.maxFontSize, tempElement, draggingArea);
    if (maxFontSizeAvailable) {
      dispatch(
        setMaxAvailableFontSize({
          imprintAreaKey: props.imprintAreaKey,
          guid,
          maxAvailableFontSize: fontSizeRange.maxFontSize,
        })
      );
      return;
    }

    let fontSizeTrying = Math.round((tempElement.data.fontSize + tempElement.ui.maxFontSize) / 2);
    //tempElement.data = { ...tempElement.data, fontSize };
    let previousAvailble;
    while (true) {
      let fontSizeAvailable = checkFontSizeAvailable(fontSizeTrying, tempElement, draggingArea);
      if (fontSizeAvailable) {
        if (previousAvailble === false) {
          break;
        }
        fontSizeTrying++;
        previousAvailble = true;
      } else {
        fontSizeTrying--;
        if (previousAvailble === true) {
          break;
        }
        previousAvailble = false;
      }
    }

    dispatch(
      setMaxAvailableFontSize({ imprintAreaKey: props.imprintAreaKey, guid, maxAvailableFontSize: fontSizeTrying })
    );
  }
};

const checkFontSizeAvailable = (fontSize, tempElement, draggingArea) => {
  const { maxWidth, maxHeight } = tempElement.ui;
  const { direction } = tempElement.data;

  const elementSize = getElementSizeByFontSize(tempElement.ui.maxFontSize, maxWidth, maxHeight, fontSize);

  const width = elementSize.width;
  const height = elementSize.height;
  let noRotateRect = { x: tempElement.data.x, y: tempElement.data.y, width, height };
  let textRotateResult = rotateText(getRectPoints(noRotateRect), direction);
  const textOutlineRect = textRotateResult.outlineRect;
  tempElement.ui = { ...tempElement.ui, outlineRect: textOutlineRect };
  // update the data by new width and height
  tempElement.data = { ...tempElement.data, width, height };
  // if the element size doesn't fit the canvas or side, trigger the error callback
  const checkResult = elementLogics.checkTextElementFitness(draggingArea, textOutlineRect, constants.elementType.Text);
  return checkResult.canvasFit && checkResult.sideFit;
};

/** process the element to validate/modify it's size and position
 * @param  {Object} draggingArea
 * @param  {Object} tempElement - element object {data, ui}
 * @param  {Object} callbacks - callbacks after the element is processed {success, error}
 * @param  {Object} fontSizeRange=null - fontSizeRange object
 * @param  {Boolean} initElement=false - if it's initializing elements
 */
const processChangedElement = function (
  draggingArea,
  tempElement,
  callbacks,
  fontSizeRange = null,
  initElement = false,
  isNextgenUi = false
) {
  const { direction } = tempElement.data;
  const { maxWidth, maxHeight } = tempElement.ui;

  let width, height;
  let textOutlineRect;
  while (true) {
    // get element size by font size
    const elementSize = getElementSizeByFontSize(
      tempElement.ui.maxFontSize,
      maxWidth,
      maxHeight,
      tempElement.data.fontSize
    );

    width = elementSize.width;
    height = elementSize.height;
    let noRotateRect = { x: tempElement.data.x, y: tempElement.data.y, width, height };
    let textRotateResult = rotateText(getRectPoints(noRotateRect), direction);
    textOutlineRect = textRotateResult.outlineRect;
    tempElement.ui = { ...tempElement.ui, outlineRect: textOutlineRect };
    // update the data by new width and height
    tempElement.data = { ...tempElement.data, width, height };
    // if the element size doesn't fit the canvas or side, trigger the error callback
    const checkResult = elementLogics.checkTextElementFitness(
      draggingArea,
      textOutlineRect,
      constants.elementType.Text
    );

    if (!checkResult.canvasFit || !checkResult.sideFit) {
      // for initializing element, lower the font size until it can fit the canvas and side, or trigger the error callback
      if (initElement && tempElement.data.fontSize !== fontSizeRange.minFontSize) {
        tempElement.data.fontSize--;
        continue;
      } else {
        // trigger the error callback for non-initializing element as long as it doesn't fit
        callbacks.error(checkResult);
        return false;
      }
    } else {
      // the element fits the canvas and side, terminate the loop
      break;
    }
  }

  // keep the elment inside the canvas
  let newSize = { width: textOutlineRect.width, height: textOutlineRect.height };
  if (newSize.width > draggingArea.width || newSize.height > draggingArea.height) {
    newSize = adjustImageSizeToFitContainer(
      { width: newSize.width, height: newSize.height },
      { width: draggingArea.width, height: draggingArea.height }
    );
  }

  let textTempElement = { data: tempElement.data, ui: { outlineRect: textOutlineRect } };

  let realElement = baseElementLogics.keepTextElementInCanvas(
    draggingArea,
    textTempElement,
    {
      width: newSize.width,
      height: newSize.height,
    },
    isNextgenUi
  );

  // keep the element insdie the side
  const realPos = baseElementLogics.getRealPosToKeepElementInside(
    draggingArea,
    { x: realElement.x, y: realElement.y },
    { width: tempElement.data.width, height: tempElement.data.height },
    direction
  );

  // update the element position
  tempElement.data.x = realPos.x;
  tempElement.data.y = realPos.y;
  // update the outlineRect position
  tempElement.ui.outlineRect.x = realPos.x;
  tempElement.ui.outlineRect.y = realPos.y;

  // trigger the success callback
  callbacks.success(tempElement);
  return true;
};

const addTextElementAfterPositionCheck = (imprintAreaKey, textElement) => (dispatch, getState) => {
  const state = getState();

  const canvasData = getCurrentCanvasData(state);

  const textList = canvasData.textList;

  offsetNewRecentArtOrText(textElement, textList);

  dispatch(textActions.addTextElement({ imprintAreaKey, textElement }));
};

/** add new element or initial element to store
 * @param  {function} dispatch - redux dispatch
 * @param  {String} imprintAreaKey
 * @param  {Object} draggingArea
 * @param  {Object} textElement - text element object
 * @param  {Object} fontSizeRange - font size range object
 * @param  {float} studioScale - studio scale
 * @param  {Number} vendorId - vendor id
 * @param  {Boolean} initElement=false - if it's initializing element
 */
const addElementInternal = function (
  dispatch,
  imprintAreaKey,
  draggingArea,
  textElement,
  fontSizeRange,
  studioScale,
  vendorId,
  scaleFactor,
  initElement,
  isNextgenUi,
  useColorImage = false,
  colorImageUrl = '',
  useDeboss = false,
  setEditing = false
) {
  // request the server
  elementLogics
    .getTextImage(
      textElement.ui.maxFontSize,
      textElement.data.imprintText || textElement.data.defaultText,
      textElement.data.fontFace,
      textElement.ui.fontFileName,
      textElement.data.isBold,
      textElement.data.isItalic,
      textElement.data.isUnderline,

      //test - Temporarily set textElement.data.color.colorReference="000000" if it is undefined
      textElement.data.color ? textElement.data.color.colorReference : '000000',

      textElement.data.horizonMultiAlign,
      textElement.data.outlineThickness,
      textElement.data.outlineColor ? textElement.data.outlineColor.colorReference : '',
      studioScale,
      vendorId,
      useColorImage,
      colorImageUrl,
      useDeboss,
      scaleFactor
    )
    .then((res) => {
      if (!res || !res.data) {
        return;
      }

      // get element size by font size
      const { width, height } = getElementSizeByFontSize(
        textElement.ui.maxFontSize,
        res.data.maxWidth,
        res.data.maxHeight,
        textElement.data.fontSize
      );

      // get min element size by min font size
      const minElementSize = getElementSizeByFontSize(
        textElement.ui.maxFontSize,
        res.data.maxWidth,
        res.data.maxHeight,
        fontSizeRange.minFontSize
      );
      // update ui
      textElement.ui.base64Image = res.data.base64Image;
      textElement.ui.maxWidth = res.data.maxWidth;
      textElement.ui.maxHeight = res.data.maxHeight;
      textElement.ui.marginLeft = res.data.marginLeft;
      textElement.ui.marginTop = res.data.marginTop ?? 0;
      textElement.ui.minWidth = minElementSize.width;
      textElement.ui.minHeight = minElementSize.height;
      textElement.ui.outlineRect.width = width;
      textElement.ui.outlineRect.height = height;
      textElement.ui.visible = true;
      const textValue = textElement.data.imprintText ?? '';
      textElement.ui.inputState = { text: textValue, caretPos: textValue.length };

      // update data
      textElement.data.width = width;
      textElement.data.height = height;

      // process the changed element
      const processChangedElementInternal = function (inputElement) {
        // success callback
        const success = function (element) {
          dispatch(addTextElementAfterPositionCheck(imprintAreaKey, element));
          dispatch(addRecentlyUsedColor(element.data.color));
        };

        // error callback
        const error = function (checkResult) {
          if (!checkResult.canvasFit) {
            dispatch(mainActions.showMessageBox(constants.MESSAGE_ELEMENT_NOT_FIT));
          } else if (!checkResult.sideFit) {
            dispatch(mainActions.showMessageBox(constants.MESSAGE_ELEMENT_NOT_FIT));
          }
        };
        processChangedElement(draggingArea, inputElement, { success, error }, fontSizeRange, true, isNextgenUi);

        dispatch(calculateMaxAvailableFontSize({ guid: inputElement.ui.guid, imprintAreaKey }));
        if (setEditing) {
          dispatch(
            setIsEditingText({
              imprintAreaKey,
              guid: inputElement.ui.guid,
              isEditing: true,
            })
          );

          const screenMode = getScreenMode();

          if (screenMode === nextgenScreenMode.small) {
            dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.None } }));
          } else {
            dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.EditTextPanel } }));
          }
        }
      };

      if (initElement) {
        processChangedElementInternal(textElement);
        dispatch(initUndoRedoList());
      } else {
        dispatch(
          addNewElementForText((elementId, layerIndex) => {
            textElement.data.itemElementId = elementId;
            textElement.data.zIndex = layerIndex;
            processChangedElementInternal(textElement);
            dispatch(pushToUndoList(constants.undoRedoType.ChangeTemplateOrEditElement));

            if (isNextgenUi && textElement.data.imprintText) {
              dispatch(updateFullPreview());
            } else {
              dispatch(hideWaitingCover());
            }
          })
        );
      }
    });
};

const addElementInternalFromCart = function (
  dispatch,
  imprintAreaKey,
  textElement,
  fontSizeRange,
  studioScale,
  vendorId,
  scaleFactor,
  draggingArea,
  editScreenPrintedDigitalItem,
  useImageColor = false,
  imageColorUrl = '',
  useDeboss = false
) {
  // request the server
  elementLogics
    .getTextImage(
      textElement.ui.maxFontSize,
      textElement.data.imprintText || textElement.data.defaultText,
      textElement.data.fontFace,
      textElement.ui.fontFileName,
      textElement.data.isBold,
      textElement.data.isItalic,
      textElement.data.isUnderline,
      textElement.data.color ? textElement.data.color.colorReference : '000000',
      textElement.data.horizonMultiAlign,
      textElement.data.outlineThickness,
      textElement.data.outlineColor ? textElement.data.outlineColor.colorReference : '',
      studioScale,
      vendorId,
      useImageColor,
      imageColorUrl,
      useDeboss,
      scaleFactor,
      textElement.ui.guid,
      true
    )
    .then((res) => {
      if (!res || !res.data) {
        return;
      }
      // get min element size by min font size
      const minElementSize = getElementSizeByFontSize(
        textElement.ui.maxFontSize,
        res.data.maxWidth,
        res.data.maxHeight,
        fontSizeRange.minFontSize
      );

      const base64Image = res.data.base64Image;
      const maxWidth = res.data.maxWidth;
      const maxHeight = res.data.maxHeight;
      const marginLeft = res.data.marginLeft;

      let responseIncrement = {};
      responseIncrement.ui = {
        base64Image,
        maxWidth,
        maxHeight,
        marginLeft,
        minWidth: minElementSize.width,
        minHeight: minElementSize.height,
        visible: true,
        inputState: { text: textElement.data.imprintText, caretPos: textElement.data.imprintText.length },
      };
      textElement = utils.deepMerge(textElement, responseIncrement);

      if (editScreenPrintedDigitalItem) {
        // success callback
        const success = function (textElement) {
          dispatch(elementActions.changeElement({ imprintAreaKey, element: textElement }));
        };

        // error callback
        const error = function (checkResult) {
          if (!checkResult.canvasFit) {
            dispatch(mainActions.showMessageBox(constants.MESSAGE_ELEMENT_NOT_FIT));
          } else if (!checkResult.sideFit) {
            dispatch(mainActions.showMessageBox(constants.MESSAGE_ELEMENT_NOT_FIT));
          }
        };
        processChangedElement(draggingArea, textElement, { success, error }, fontSizeRange, true);
      } else {
        dispatch(elementActions.changeElement({ imprintAreaKey, element: textElement }));
        dispatch(updateUndoListRecord(imprintAreaKey, textElement));
      }

      dispatch(calculateMaxAvailableFontSize({ guid: textElement.ui.guid, imprintAreaKey }));
      dispatch(initUndoRedoList());
    });
};

export const getDisplayFontListFromFontList = function (fontList) {
  const displayFontList = [];
  fontList.forEach((item1) => {
    if (!displayFontList.some((item2) => item2.fontFace === item1.fontFace)) {
      displayFontList.push({
        fontFace: item1.fontFace,
        fontCode: item1.fontCode,
        fontImgFileName: item1.fontImgFileName,
        fontFileName: item1.fontFileName,
        selected: false,
        recentlyUsed: item1.recentlyUsed,
      });
    }
  });
  return displayFontList;
};

export const getElementSizeByFontSize = function (maxFontSize, maxWidth, maxHeight, currentFontSize) {
  const scale = currentFontSize / maxFontSize;
  const width = Math.round(scale * maxWidth);
  const height = Math.round(scale * maxHeight);
  return { width, height };
};

export const getFontSizeByElementSize = function (elementSize, fontSizeRange, maxWidth, maxHeight) {
  const scale = maxWidth > maxHeight ? elementSize.width / maxWidth : elementSize.height / maxHeight;
  let fontSize = Math.floor(fontSizeRange.maxFontSize * scale);
  if (fontSize <= fontSizeRange.maxFontSize && fontSize >= fontSizeRange.minFontSize) {
    const fontSizeScale = fontSize / fontSizeRange.maxFontSize;
    const newWidth = Math.floor(maxWidth * fontSizeScale);
    const newHeight = Math.floor(maxHeight * fontSizeScale);
    return {
      success: true,
      fontSize,
      width: newWidth,
      height: newHeight,
    };
  }
  return {
    success: false,
  };
};

// middlewares BEGIN: dispatch to update the store after async calls return values
export const changeFontSize = function (fontSize, guid, successCallback, errorCallback) {
  return (dispatch, getState) => {
    const state = getState();
    let draggingArea = getCanvasDraggingArea(state);
    let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);

    const textElement = elementLogics.getElement(state.textDict, imprintAreaKey, guid);
    const { maxFontSize, maxWidth, maxHeight } = textElement.ui;
    const elementSize = getElementSizeByFontSize(maxFontSize, maxWidth, maxHeight, fontSize);
    let increment = {};
    increment.data = { ...elementSize, fontSize };

    // merge front end increment
    let tmpElement = utils.deepMerge(textElement, increment);

    // success callback
    const success = function (element) {
      successCallback && successCallback();
      dispatch(elementActions.changeElement({ imprintAreaKey, element }));
      dispatch(pushToUndoList(constants.undoRedoType.ChangeTemplateOrEditElement));
    };

    // error callback
    const error = function (checkResult) {
      errorCallback && errorCallback();
      if (!checkResult.canvasFit) {
        dispatch(mainActions.showMessageBox(constants.MESSAGE_ELEMENT_NOT_FIT));
      } else if (!checkResult.sideFit) {
        dispatch(mainActions.showMessageBox(constants.MESSAGE_ELEMENT_NOT_FIT));
      }
    };

    // process the change to decide if we should update the store
    processChangedElement(draggingArea, tmpElement, { success, error });
  };
};

export const changeText = function (newText, guid) {
  return (dispatch) => {
    let increment = {};
    increment.data = { imprintText: newText };
    dispatch(changeElement({ increment, guid, pushToUndo: true, adjustSize: true, waiting: true }));
  };
};
export const changeColor = function (guid, cmyk, colorId, colorReference, colorType, colorDescription) {
  return (dispatch) => {
    let increment = {};
    increment.data = {
      color: {
        cmyk,
        colorId,
        colorReference,
        colorType,
        colorDescription,
      },
    };
    dispatch(changeElement({ increment, guid, noProcess: true, waiting: true }));
  };
};

export const changeTextAlign = function (guid, alignment) {
  return (dispatch) => {
    let increment = {};
    increment.data = {
      horizonMultiAlign: alignment,
    };
    dispatch(changeElement({ increment, guid, noProcess: true, pushToUndo: true, waiting: true }));
  };
};
export const changeOutlineThickness = function (guid, outlineThickness) {
  return (dispatch) => {
    let increment = {};
    increment.data = {
      outlineThickness: outlineThickness,
    };
    dispatch(changeElement({ increment, guid, noProcess: true, pushToUndo: true, waiting: true }));
  };
};

export const changeOutlineColor = function (guid, cmyk, colorId, colorReference, colorType, colorDescription) {
  return (dispatch) => {
    let increment = {};
    increment.data = {
      outlineColor: {
        cmyk,
        colorId,
        colorReference,
        colorType,
        colorDescription,
      },
    };
    dispatch(changeElement({ increment, guid, noProcess: true, pushToUndo: true, waiting: true }));
  };
};

export const changeFont = function (selectedFont, fontStyleBeforeChangingFont, guid, successCallback, errorCallback) {
  return (dispatch, getState) => {
    const state = getState();

    const imprintAreaCode = mainSelectors.getCurrentImprintAreaCode(state);
    const fontList = state.fontDict[imprintAreaCode];
    let { isBold, isItalic } = fontStyleBeforeChangingFont;
    const { fontFace, fontCode, fontFileName, fontImgFileName } = selectedFont;
    if (
      !fontList.some((f) => f.hasBold === isBold && f.hasItalic === isItalic && f.fontFace === selectedFont.fontFace)
    ) {
      // if current style is not available for the selected font, then use selected font's own style
      let selectedFontDetail = fontList.find((f) => f.fontFace === selectedFont.fontFace);
      isBold = selectedFontDetail.hasBold;
      isItalic = selectedFontDetail.hasItalic;
    }

    let increment = {};
    increment.data = { isBold, isItalic, fontFace, fontCode };
    increment.ui = { fontFileName, fontImgFileName };

    dispatch(changeElement({ increment, guid, successCallback, errorCallback, pushToUndo: true, waiting: true }));
  };
};

export const changeTextStyle = function (guid, styleToChange) {
  return (dispatch, getState) => {
    const state = getState();
    let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    const imprintAreaCode = mainSelectors.getCurrentImprintAreaCode(state);
    const textElement = elementLogics.getElement(state.textDict, imprintAreaKey, guid);
    const { isBold, isItalic, isUnderline, fontFace, fontCode } = textElement.data;
    const { fontFileName } = textElement.ui;
    const fontList = state.fontDict[imprintAreaCode];
    let isAvailableStyle = true;
    let styleAvailable = checkStyleAvailable(fontList, styleToChange, {
      isBold,
      isItalic,
      isUnderline,
      fontFace,
      isAvailableStyle,
    });
    if (styleAvailable.isAvailableStyle) {
      let increment = {};
      increment.data = { isBold, isItalic, isUnderline, fontCode };
      increment.ui = { fontFileName };
      if (styleToChange === constants.textStyleType.Bold) {
        if (isItalic !== styleAvailable.isItalic) {
          increment.data.isItalic = styleAvailable.isItalic;
        }
        increment.data.isBold = !isBold;
      } else if (styleToChange === constants.textStyleType.Italic) {
        if (isBold !== styleAvailable.isBold) {
          increment.data.isBold = styleAvailable.isBold;
        }
        increment.data.isItalic = !isItalic;
      } else if (styleToChange === constants.textStyleType.Underline) {
        increment.data.isUnderline = !isUnderline;
      }

      let font = fontList.find(
        (f) => f.hasBold === increment.data.isBold && f.hasItalic === increment.data.isItalic && f.fontFace === fontFace
      );
      increment.data.fontCode = font.fontCode;
      increment.ui.fontFileName = font.fontFileName;

      dispatch(changeFontStyle({ imprintAreaKey, guid, increment }));
      dispatch(changeElement({ increment, guid, pushToUndo: true }));
    } else {
      dispatch(mainActions.showMessageBox('The style you selected is not available'));
    }
  };
};

export const returnLastAppliedTextStyle = function (guid, textStyle) {
  return (dispatch, getState) => {
    const state = getState();
    const imprintAreaCode = mainSelectors.getCurrentImprintAreaCode(state);
    const fontList = state.fontDict[imprintAreaCode];
    let font = fontList.find(
      (f) => f.hasBold === textStyle.isBold && f.hasItalic === textStyle.isItalic && f.fontFace === textStyle.fontFace
    );
    const increment = {
      data: {
        fontCode: font.fontCode,
        isBold: textStyle.isBold,
        isItalic: textStyle.isItalic,
        isUnderline: textStyle.isUnderline,
      },
      ui: { fontFileName: font.fontFileName, fontImgFileName: font.fontImgFileName },
    };
    dispatch(changeElement({ increment, guid }));
  };
};

export const applyStyleToAllText = function (guid) {
  return (dispatch, getState) => {
    const state = getState();
    let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    const textList = state.textDict[imprintAreaKey];
    const textElement = elementLogics.getElement(state.textDict, imprintAreaKey, guid);
    const { fontFace, fontCode, color, fontSize, isBold, isItalic, isUnderline, outlineThickness, outlineColor } =
      textElement.data;
    const { fontFileName, fontImgFileName } = textElement.ui;

    const increment = {
      data: { fontFace, fontCode, color, fontSize, isBold, isItalic, isUnderline, outlineThickness, outlineColor },
      ui: { fontFileName, fontImgFileName },
    };

    const otherTextList = textList.filter((element) => element.ui.guid !== guid);
    if (otherTextList.length > 0) {
      const guids = otherTextList.map((element) => element.ui.guid);
      dispatch(changeElements(increment, guids, null, constants.pushToUndoListMode.AddNew));
    }
  };
};

// note: applyOneStyleToAllText is used for mobile
export const applyOneStyleToAllText = function (guid, increment) {
  return (dispatch, getState) => {
    const state = getState();
    let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    const textList = state.textDict[imprintAreaKey];
    const otherTextList = textList.filter((element) => element.ui.guid !== guid);
    if (otherTextList.length > 0) {
      const guids = otherTextList.map((element) => element.ui.guid);
      dispatch(changeElements(increment, guids));
    }
  };
};

export const applyFontSizeToAllText = function (guid, fontSize) {
  return (dispatch) => {
    const increment = {
      data: { fontSize },
    };
    dispatch(applyOneStyleToAllText(guid, increment));
  };
};

export const applyFontFaceToAllText = function (guid, fontFace, fontCode, fontFileName, fontImgFileName) {
  return (dispatch, getState) => {
    const state = getState();
    let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    const imprintAreaCode = mainSelectors.getCurrentImprintAreaCode(state);
    const textList = state.textDict[imprintAreaKey];
    const fontList = state.fontDict[imprintAreaCode];
    const otherTextList = textList.filter((element) => element.ui.guid !== guid);
    if (otherTextList.length > 0) {
      otherTextList.forEach((text) => {
        let isBold = text.data.isBold;
        let isItalic = text.data.isItalic;
        if (!fontList.some((f) => f.hasBold === isBold && f.hasItalic === isItalic && f.fontFace === fontFace)) {
          let selectedFontDetail = fontList.find((f) => f.fontFace === fontFace);
          isBold = selectedFontDetail.hasBold;
          isItalic = selectedFontDetail.hasItalic;
          fontCode = selectedFontDetail.fontCode;
          fontFileName = selectedFontDetail.fontFileName;
          fontImgFileName = selectedFontDetail.fontImgFileName;
        }
        const increment = {
          data: { fontFace, fontCode, isBold, isItalic },
          ui: { fontFileName, fontImgFileName },
        };
        dispatch(changeElement({ increment, guid: text.ui.guid }));
      });
    }
  };
};

export const applyTextStyleToAllText = function (guid, isBold, isItalic, isUnderline) {
  return (dispatch, getState) => {
    const state = getState();
    let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    const imprintAreaCode = mainSelectors.getCurrentImprintAreaCode(state);
    const textList = state.textDict[imprintAreaKey];
    const fontList = state.fontDict[imprintAreaCode];
    const otherTextList = textList.filter((element) => element.ui.guid !== guid);
    let font = {};
    if (otherTextList.length > 0) {
      otherTextList.forEach((text) => {
        if (
          !fontList.some((f) => f.hasBold === isBold && f.hasItalic === isItalic && f.fontFace === text.data.fontFace)
        ) {
          font = fontList.find((f) => f.fontFace === text.data.fontFace);
        } else {
          font = fontList.find(
            (f) => f.hasBold === isBold && f.hasItalic === isItalic && f.fontFace === text.data.fontFace
          );
        }
        const increment = {
          data: { fontCode: font.fontCode, isBold: font.hasBold, isItalic: font.hasItalic, isUnderline },
          ui: { fontFileName: font.fontFileName, fontImgFileName: font.fontImgFileName },
        };
        dispatch(changeElement({ increment, guid: text.ui.guid }));
      });
    }
  };
};

export const applyColorToAllText = function (guid, color) {
  return (dispatch) => {
    const increment = {
      data: { color },
    };
    dispatch(applyOneStyleToAllText(guid, increment));
  };
};

export const applyOutlineToAllText = function (guid, outlineColor, outlineThickness) {
  return (dispatch) => {
    const increment = {
      data: { outlineColor, outlineThickness },
    };
    dispatch(applyOneStyleToAllText(guid, increment));
  };
};

export const changeTemplateElement = function (commonTemplate, isTemplateEditor, text) {
  return (dispatch, getState) => {
    const state = getState();
    const vendorId = getVendorId(state);
    const canvasData = getCurrentCanvasData(state);
    const currentStudioItemType = mainSelectors.getStudioItemType(state);
    let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    const itemId = mainSelectors.getItemId(state);
    const imprintAreaKeys = imprintAreaKey.split('-');
    let imprintAreaCode = imprintAreaKeys[0];
    let imprintLocation = imprintAreaKeys[1];
    let specialTemplates = Object.keys(state.specialTemplateDict).includes(imprintAreaKey)
      ? state.specialTemplateDict[imprintAreaKey]
      : [];
    let targetTemplate = null;
    let defaultTemplate = specialTemplates.find((template) => template.templateType === TemplateType.DEFAULT);
    let blankTemplate = specialTemplates.find((template) => template.templateType === TemplateType.BLANK);
    const getTextElementMethod = isTemplateEditor ? getTextElementForAdminTool : getTextElement;
    if (defaultTemplate) {
      targetTemplate = defaultTemplate;
    } else if (blankTemplate) {
      targetTemplate = blankTemplate;
    } else {
      targetTemplate = {
        templateId: 0,
      };
    }
    let request = isTemplateEditor
      ? {
          templateId: commonTemplate.templateId,
          compositionItemId: canvasData.id,
          previewResolution: canvasData.previewResolution,
          itemId: itemId,
          imprintAreaCode: imprintAreaCode,
          imprintLocation: imprintLocation,
        }
      : {
          templateId: commonTemplate.templateId,
          defaultTemplateId: targetTemplate.templateId,
          compositionItemId: canvasData.id,
          previewResolution: canvasData.previewResolution,
          itemId: itemId,
          vendorId: vendorId,
          imprintAreaCode: imprintAreaCode,
          imprintLocation: imprintLocation,
        };
    getTextElementMethod(request).then(function (response) {
      if (!text) {
        if (isTemplateEditor) dispatch(checkImprintColorEmpty(currentStudioItemType, imprintAreaKey, response.data));
        dispatch(updateTextStyle(response.data, isTemplateEditor));
      } else {
        dispatch(addTextElement(text, response.data, true));
      }
    });
  };
};

export const retrievalImprintAreaKeys = function (
  state,
  updatePreviewsForAll,
  currentImprintAreaKey,
  selectedImprintAreaKeys,
  fromUpdateImprintSizing
) {
  let retrievaledImprintAreaKeys = [];
  let retrievaledImprintAreaKeyList = [];
  let selectedImprintAreaKey = '';
  let vignetteList = [];
  let imprintLocationList = [];
  let imprintLocationDict = {};
  let logoLocationDict = {};
  let nonDigitalTextDataDict = {};
  let imprintAreaDimensionDict = {};
  let imprintAreaList = [];
  const currentStudioItemType = mainSelectors.getStudioItemType(state);
  if (currentStudioItemType === studioItemType.nonDigital) {
    for (let chosenImprintAreaKey of selectedImprintAreaKeys) {
      if (state.imprintAreaDict[chosenImprintAreaKey] !== undefined) {
        state.imprintAreaDict[chosenImprintAreaKey].vignettes.forEach((vignette) => {
          vignetteList.push(vignette);
        });
      }
      if (state.imprintLocationDict[chosenImprintAreaKey] !== undefined) {
        state.imprintLocationDict[chosenImprintAreaKey].forEach((imprintLocation) => {
          imprintLocationList.push(imprintLocation.locationCode);
        });
      }
    }
    const vignettes = vignetteList.sort();
    for (let i = 0; i < vignettes.length - 1; i++) {
      if (vignettes[i] === vignettes[i + 1]) {
        break;
      } else {
        retrievaledImprintAreaKeys.push(currentImprintAreaKey);
        selectedImprintAreaKey = '';
        break;
      }
    }
    if (retrievaledImprintAreaKeys.length === 0) {
      const imprintLocations = imprintLocationList.sort();
      for (let i = 0; i < imprintLocations.length - 1; i++) {
        if (imprintLocations[i] === imprintLocations[i + 1]) {
          break;
        } else {
          selectedImprintAreaKeys.forEach((key) => {
            retrievaledImprintAreaKeys.push(key);
          });
          selectedImprintAreaKey = currentImprintAreaKey;
          break;
        }
      }
      if (retrievaledImprintAreaKeys.length === 0) {
        retrievaledImprintAreaKeys.push(currentImprintAreaKey);
        selectedImprintAreaKey = '';
      }
    }
  } else if (
    currentStudioItemType === studioItemType.digital ||
    currentStudioItemType === studioItemType.screenPrintedDigital
  ) {
    selectedImprintAreaKeys.forEach((key) => {
      retrievaledImprintAreaKeys.push(key);
    });
  }
  // the unused key will not be passed back
  for (let retrievaledImprintAreaKey of retrievaledImprintAreaKeys) {
    const currentImprintOptionType = getImprintOptionType(state, retrievaledImprintAreaKey);
    if (
      fromUpdateImprintSizing &&
      (currentImprintOptionType === constants.imprintOptionType.TextOnly ||
        currentImprintOptionType === constants.imprintOptionType.TextLogo)
    ) {
      retrievaledImprintAreaKeyList.push(retrievaledImprintAreaKey);
    }
    if (
      !fromUpdateImprintSizing &&
      (currentImprintOptionType === constants.imprintOptionType.TextOnly ||
        currentImprintOptionType === constants.imprintOptionType.TextLogo ||
        currentImprintOptionType === constants.imprintOptionType.LogoOnly)
    ) {
      retrievaledImprintAreaKeyList.push(retrievaledImprintAreaKey);
    }
  }
  for (let imprintAreaKey of updatePreviewsForAll ? selectedImprintAreaKeys : retrievaledImprintAreaKeyList) {
    const imprintOption = getImprintFormatDetail(state, imprintAreaKey);
    const imprintFormat = imprintOption.format;
    imprintAreaList.push(imprintFormat);
    const imprintLocation = imprintOption.imprintLocation;
    imprintLocationDict[imprintAreaKey] = imprintLocation;
    const logoLocation = imprintOption.logoLocation;
    logoLocationDict[imprintAreaKey] = logoLocation;
    const textDataDict = textSelectors.getNonDigitalTextDataDict(state);
    if (textDataDict[imprintAreaKey] !== undefined) {
      nonDigitalTextDataDict[imprintAreaKey] = textDataDict[imprintAreaKey];
    }
    if (fromUpdateImprintSizing) {
      const imprintAreaDimension = mainSelectors.getImprintAreaDimension(state)[imprintAreaKey];
      const currentImprintAreaDimension =
        imprintAreaDimension && Object.keys(imprintAreaDimension).includes(logoLocation)
          ? imprintAreaDimension[logoLocation]
          : { width: 0.0, height: 0.0 };
      imprintAreaDimensionDict[imprintAreaKey] = currentImprintAreaDimension;
    }
  }
  let retrievaledData = {};
  retrievaledData = {
    retrievaledImprintAreaKeys: updatePreviewsForAll ? selectedImprintAreaKeys : retrievaledImprintAreaKeyList,
    selectedImprintAreaKey: updatePreviewsForAll ? '' : selectedImprintAreaKey,
    imprintAreaList,
    imprintLocationDict,
    logoLocationDict,
    nonDigitalTextDataDict,
    imprintAreaDimensionDict,
  };
  return retrievaledData;
};

export const updateNonDigitalFullPreview = function (props = {}) {
  return (dispatch, getState) => {
    const { updatePreviewsForAll = false, needUpdatePreview, successCallback, errorCallback, finallyCallback } = props;
    const state = getState();
    const itemId = getIsLiteParentChildItem(state)
      ? getChildItemIdFromBomSelectionForLite(state)
      : mainSelectors.getItemId(state);
    const vendorId = mainSelectors.getVendorId(state);
    const currentImprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    const selectedImprintAreaKeys = getSelectedImprintAreaKeys(state);
    const retrievaledData = retrievalImprintAreaKeys(
      state,
      updatePreviewsForAll,
      currentImprintAreaKey,
      selectedImprintAreaKeys,
      true
    );
    let heightNotFit = false;
    let imprintNotFit = false;
    // only TextOnly or TextLogo need getImprintSizing
    if (retrievaledData.retrievaledImprintAreaKeys.length > 0) {
      let request = {
        imprintAreaDimension: retrievaledData.imprintAreaDimensionDict,
        imprintArea: retrievaledData.imprintAreaList,
        imprintLocationCode: retrievaledData.imprintLocationDict,
        itemId: itemId,
        logoLocationCode: retrievaledData.logoLocationDict,
        texts: retrievaledData.nonDigitalTextDataDict,
        vendorId: vendorId,
      };
      dispatch(mainActions.showWaitingCover());
      getImprintSizing(request)
        .then(function (response) {
          for (let imprintAreaKey of retrievaledData.retrievaledImprintAreaKeys) {
            const imprintSizingData = response.data.imprintSizing[imprintAreaKey];
            if (imprintSizingData !== undefined) {
              const scale = imprintSizingData.scale;
              dispatch(mainActions.changeScale({ scale, imprintAreaKey }));
              const imprintAreaDimension = imprintSizingData.imprintAreaDimension;
              const logoLocation = retrievaledData.logoLocationDict[imprintAreaKey];
              dispatch(mainActions.changeImprintAreaDimension({ imprintAreaDimension, logoLocation, imprintAreaKey }));
              const fontSizes = imprintSizingData.fontSizes;
              const imprintFits = imprintSizingData.imprintFits;
              dispatch(textActions.changeFontSizesAndImprintFits({ fontSizes, imprintFits, imprintAreaKey }));
              const heightFits = imprintSizingData.heightFits;
              dispatch(mainActions.changeHeightFits({ heightFits, imprintAreaKey }));
              if (currentImprintAreaKey === imprintAreaKey) {
                const imprintFitHasFalse = imprintFits.includes(false);
                if (!heightFits) {
                  dispatch(
                    mainActions.showMessageBox({
                      show: true,
                      message: TOO_MANY_LINES_ENTERED_MESSAGE,
                    })
                  );
                  heightNotFit = true;
                } else if (imprintFitHasFalse) {
                  dispatch(
                    mainActions.showMessageBox({
                      show: true,
                      message: TOO_LONG_TEXT_ENTERED_MESSAGE,
                    })
                  );
                  imprintNotFit = true;
                }
              }
            } else if (response.data.imprintSizing[currentImprintAreaKey] === undefined) {
              dispatch(mainActions.hideWaitingCover());
            }
          }
          const hasInvalidCharacter = textSelectors.hasInvalidCharacter(state);
          if (!hasInvalidCharacter && !heightNotFit && !imprintNotFit) {
            if (needUpdatePreview) {
              dispatch(
                updateFullPreview({
                  updatePreviewsForAll,
                  successCallback,
                  finallyCallback,
                })
              );
            } else {
              // callback, if no need update preview
              successCallback && successCallback();
            }
          } else {
            dispatch(mainActions.hideWaitingCover());
            errorCallback && errorCallback();
          }
        })
        .catch((error) => {
          console.error(error);
          dispatch(mainActions.hideWaitingCover());
        });
    } else {
      // logoOnly updateFullPreview directly
      dispatch(updateFullPreview({ updatePreviewsForAll, successCallback, errorCallback, finallyCallback }));
    }
  };
};

// upsells can only be nonDigital products
export const updateUpsellImprintSizing = function (props = {}) {
  return (dispatch, getState) => {
    const { needUpdatePreview = false, successCallback, errorCallback } = props;
    const state = getState();
    const upsellItemId = mainSelectors.getCurrentUpsellItemId(state);
    const currentUpsell = mainSelectors.getCurrentUpsell(state);
    const upsellTextDataDict = getCurrentUpsellTextDataDict(state);
    const vendorId = mainSelectors.getVendorId(state);
    const upsellImprintAreaKey = getCurrentUpsellImprintAreaKey(state);
    let upsellHeightNotFit = false;
    let upsellImprintNotFit = false;
    let request = {
      imprintAreaDimension: currentUpsell.imprintAreaDimension,
      imprintArea: currentUpsell.imprintAreas,
      imprintLocationCode: currentUpsell.imprintLocationCode,
      itemId: upsellItemId,
      logoLocationCode: currentUpsell.logoLocationCode,
      texts: upsellTextDataDict,
      vendorId: vendorId,
    };
    getImprintSizing(request)
      .then(function (response) {
        if (response.data.imprintSizing[upsellImprintAreaKey] !== undefined) {
          const imprintSizingData = response.data.imprintSizing[upsellImprintAreaKey];
          const upsellScale = imprintSizingData.scale;
          dispatch(changeUpsellScale({ upsellScale, upsellImprintAreaKey, upsellItemId }));
          const upsellImprintAreaDimension = imprintSizingData.imprintAreaDimension;
          dispatch(
            changeUpsellImprintAreaDimension({ upsellImprintAreaDimension, upsellImprintAreaKey, upsellItemId })
          );
          const upsellFontSizes = imprintSizingData.fontSizes;
          const upsellImprintFits = imprintSizingData.imprintFits;
          dispatch(
            changeUpsellFontSizesAndUpsellImprintFits({
              upsellFontSizes,
              upsellImprintFits,
              upsellImprintAreaKey,
              upsellItemId,
            })
          );
          const upsellHeightFits = imprintSizingData.heightFits;
          dispatch(changeUpsellHeightFits({ upsellHeightFits, upsellImprintAreaKey, upsellItemId }));
          const hasInvalidCharacter = textSelectors.hasInvalidCharacter(state);
          const upsellImprintFitHasFalse = upsellImprintFits.includes(false);
          if (!upsellHeightFits) {
            dispatch(
              mainActions.showMessageBox({
                show: true,
                message: TOO_MANY_LINES_ENTERED_MESSAGE,
              })
            );
            upsellHeightNotFit = true;
          } else if (upsellImprintFitHasFalse) {
            dispatch(
              mainActions.showMessageBox({
                show: true,
                message: TOO_LONG_TEXT_ENTERED_MESSAGE,
              })
            );
            upsellImprintNotFit = true;
          }
          if (!hasInvalidCharacter && !upsellHeightNotFit && !upsellImprintNotFit) {
            if (needUpdatePreview) {
              dispatch(updateUpsellFullPreview(successCallback));
            } else {
              // callback, if no need update preview
              successCallback && successCallback();
            }
          } else {
            dispatch(mainActions.hideWaitingCover());
            errorCallback && errorCallback();
          }
        }
      })
      .catch((error) => {
        console.error(error);
        dispatch(mainActions.hideWaitingCover());
      });
  };
};

export const invalidCharactersRetrieval = function (props = {}) {
  return (dispatch, getState) => {
    const { fromUpsellText = false, fromLiteText = false } = props;
    const state = getState();
    const specialSymbols = textSelectors.getSpecialSymbols(state);
    let nonDigitalTextDataList = [];
    if (fromUpsellText) {
      nonDigitalTextDataList = getCurrentUpsellTextDataList(state);
    } else if (fromLiteText) {
      // Check text on all sides for lite
      nonDigitalTextDataList = textSelectors.getAllNonDigitalTextDataList(state);
    } else {
      nonDigitalTextDataList = textSelectors.getCurrentNonDigitalTextDataList(state);
    }
    let validCharacters =
      '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ ~!@#$%^&*()_+`-={}[]|\\:";\'<>?,./{replacement}';
    let regxCharacters =
      '^[0-9a-zA-Z\\s\\~\\!\\@\\#\\$\\%\\^\\&\\*\\(\\)\\+\\`\\-\\=\\{\\}\\[\\]\\|\\\\\\:\\"\\;\\\'\\<\\>\\?\\,\\.\\/_{replacement}]*$';
    let replacement = '';
    for (let i = 0; specialSymbols != null && i < specialSymbols.length; i++) {
      replacement += specialSymbols[i];
    }
    validCharacters = validCharacters.replace('{replacement}', replacement);
    regxCharacters = regxCharacters.replace('{replacement}', replacement);
    let regxCharacterWithSpecialSymbols = new RegExp(regxCharacters);
    let invalidCharacters = '';
    nonDigitalTextDataList &&
      nonDigitalTextDataList.forEach((text) => {
        if (!regxCharacterWithSpecialSymbols.test(text.imprintText)) {
          for (let i = 0; i < text.imprintText.length; i++) {
            if (!validCharacters.includes(text.imprintText[i])) {
              if (!invalidCharacters.includes(text.imprintText[i])) {
                if (invalidCharacters === '') {
                  invalidCharacters += text.imprintText[i];
                } else {
                  invalidCharacters += ',' + text.imprintText[i];
                }
              }
            }
          }
          dispatch(
            mainActions.showMessageBox({
              show: true,
              message: `You have entered invalid symbols:"${invalidCharacters}", please remove them and try again.`,
            })
          );
          dispatch(mainActions.hideWaitingCover());
        }
      });
    dispatch(mainActions.hasInvalidCharacter(invalidCharacters));
  };
};

export const updateTheSecondTabOnce = function () {
  return (dispatch, getState) => {
    const state = getState();
    const status = mainSelectors.getStatus(state);
    // copy the text on the first side to the second side only when the second tab / the next button is clicked for the first time and the status is NEW
    if (getConfiguratorAction(status) === configuratorAction.new) {
      let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
      let imprintAreaCode = imprintAreaKey.split('-')[0];
      const firstShiftTab = textSelectors.isFirstShiftTab(state);
      const textDict = state.textDict;
      let textList = [];
      let areaKey = '';
      const imprintAreaKeys = Object.keys(textDict);
      if (firstShiftTab) {
        dispatch(mainActions.firstShiftTab(false));
        imprintAreaKeys.forEach((key, index) => {
          if (key.includes(imprintAreaCode)) {
            if (index === 0) {
              textList = textDict[key];
            } else if (index === 1) {
              areaKey = key;
            }
            dispatch(textActions.changeTheSecondTabData({ textList, areaKey }));
          }
        });
      }
    }
  };
};

export const selectFirstLineText = function (imprintAreaKey) {
  return (dispatch, getState) => {
    const state = getState();
    const currentStudioItemType = mainSelectors.getStudioItemType(state);
    let guid = '';
    if (currentStudioItemType === studioItemType.digital) {
      const textList = textSelectors.getCurrentCanvasTextList(state);
      const minY = Math.min(...textList.map((e) => e.data.y));
      const minYText = textList.find((e) => e.data.y === minY);
      if (minYText !== undefined) guid = minYText.ui.guid;
    } else if (currentStudioItemType === studioItemType.nonDigital) {
      const textList = textSelectors.getCurrentNonDigitalTextList(state);
      guid = textList && textList[0] && textList[0].ui.guid;
    }
    if (guid !== '') {
      dispatch(selectText({ canvasKey: imprintAreaKey, imageId: guid }));
    }
  };
};

export const selectUpsellFirstLineText = function () {
  return (dispatch, getState) => {
    const state = getState();
    const upsellItemId = getCurrentUpsellItemId(state);
    const upsellImprintAreaKey = getCurrentUpsellImprintAreaKey(state);
    const upsellTextList = getCurrentUpsellTextList(state);
    dispatch(unSelectAllUpsellText({ upsellImprintAreaKey, upsellItemId }));
    dispatch(
      selectUpsellText({
        upsellImprintAreaKey,
        guid: upsellTextList[0].ui.guid,
        upsellItemId,
      })
    );
  };
};

export const updateTextStyle = function (defaultData, isTemplateEditor = false) {
  return (dispatch, getState) => {
    const state = getState();
    let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    const fontList = textSelectors.getCurrentFontList(state);
    const fontSizeRange = textSelectors.getFontSizeRange(state);
    const textElementList = elementLogics.getElementList(state.textDict, imprintAreaKey);
    const studioScale = getCurrentStudioScale(state);
    const scaleFactor = getCurrentScaleFactor(state, imprintAreaKey);
    const vendorId = getVendorId(state);

    const isHotStamped = mainSelectors.getCurrentHotStampedCheck(state);
    const isDeboss = mainSelectors.getCurrentDebossCheck(state);

    textElementList.forEach((text) => {
      const textData = defaultData.find((element) => element.itemElementId === text.data.itemElementId);
      if (textData) {
        textData.imprintText = text.data.imprintText;
        let textElement = { data: textData, ui: {} };
        let updatedTextElement = updateFontElement(fontList, textElement);
        updatedTextElement = updateMaxFontSize(fontSizeRange, updatedTextElement);
        let guids = [];
        guids.push(text.ui.guid);
        let colorImageUrl = '';
        if (isHotStamped) {
          colorImageUrl = getHotStampColorImageUrl(updatedTextElement.data.color.colorId);
        }
        // When template is changed, we need to execute the getTextImage interface to get the width and height of text
        // in order to calculate the correct position
        elementLogics
          .getTextImage(
            updatedTextElement.ui.maxFontSize,
            updatedTextElement.data.defaultText,
            updatedTextElement.data.fontFace,
            updatedTextElement.ui.fontFileName,
            updatedTextElement.data.isBold,
            updatedTextElement.data.isItalic,
            updatedTextElement.data.isUnderline,
            updatedTextElement.data.color.colorReference,
            updatedTextElement.data.horizonMultiAlign,
            updatedTextElement.data.outlineThickness,
            updatedTextElement.data.outlineColor ? updatedTextElement.data.outlineColor.colorReference : '',
            studioScale,
            vendorId,
            isHotStamped,
            colorImageUrl,
            isDeboss,
            scaleFactor
          )
          .then((res) => {
            if (!res || !res.data) {
              return;
            }
            const { width, height } = getElementSizeByFontSize(
              textElement.ui.maxFontSize,
              res.data.maxWidth,
              res.data.maxHeight,
              textElement.data.fontSize
            );

            updatedTextElement.data.width = width;
            updatedTextElement.data.height = height;

            updatedTextElement.ui.marginLeft = res.data.marginLeft;
            updatedTextElement.ui.marginTop = res.data.marginTop ?? 0;

            dispatch(
              changeElements(
                updatedTextElement,
                guids,
                isTemplateEditor ? constants.pushToUndoListMode.None : constants.pushToUndoListMode.UpdateTextElement
              )
            );

            dispatch(calculateMaxAvailableFontSize({ guid: textElement.ui.guid, imprintAreaKey }));
          });

        dispatch(mainActions.hideWaitingCover());
      }
    });
  };
};

const updateFontElement = function (fontList, textElement) {
  // check font available
  let font = fontList.find(
    (f) =>
      f.fontFace === textElement.data.fontFace &&
      f.hasBold === textElement.data.isBold &&
      f.hasItalic === textElement.data.isItalic
  );
  if (!font) {
    font = fontList.find((f) => f.fontFace === textElement.data.fontFace);
  }
  if (!font) {
    font = fontList[0];
    textElement.data.fontFace = font.fontFace;
  }

  textElement.data.fontCode = font.fontCode;
  textElement.data.isBold = font.hasBold;
  textElement.data.isItalic = font.hasItalic;
  textElement.ui.fontFileName = font.fontFileName;
  textElement.ui.fontImgFileName = font.fontImgFileName;
  return textElement;
};

const updateMaxFontSize = function (fontSizeRange, textElement) {
  //keep font size in range
  if (textElement.data.fontSize > fontSizeRange.maxFontSize) {
    textElement.data.fontSize = fontSizeRange.maxFontSize;
  } else if (textElement.data.fontSize < fontSizeRange.minFontSize) {
    textElement.data.fontSize = fontSizeRange.minFontSize;
  }

  textElement.ui.maxFontSize = fontSizeRange.maxFontSize;
  return textElement;
};

const updateTextElement = function (fontList, fontSizeRange, textData) {
  let textElement = { data: textData, ui: {} };
  let updatedTextElement = updateFontElement(fontList, textElement);
  updatedTextElement = updateMaxFontSize(fontSizeRange, updatedTextElement);
  updatedTextElement.ui.guid = uuidv4();
  updatedTextElement.ui.status = constants.elementStatus.Unselected;
  updatedTextElement.ui.outlineRect = { x: textData.x, y: textData.y, width: textData.width, height: textData.height };
  return updatedTextElement;
};

export const addTextElement = function (text, templateElement, setEditing = false) {
  return (dispatch, getState) => {
    const state = getState();
    const vendorId = mainSelectors.getVendorId(state);
    const imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    const studioScale = getCurrentStudioScale(state);
    const imprintAreaCode = mainSelectors.getCurrentImprintAreaCode(state);
    const draggingArea = getCanvasDraggingArea(state);
    const currentStudioItemType = mainSelectors.getStudioItemType(state);
    const selectedTextColor = mainSelectors.getCurrentTextColor(state, imprintAreaKey);
    const isTopToMax = getMultipleImageColorsTopToMaxCheck(state, imprintAreaKey);
    const maxColorCount = getImprintOptionMaxColorCount(state);
    const selectedImage = getCanvasImageList(state, imprintAreaKey);
    const isNextgenUi = getIsNextGenUI(state);
    const canvasData = getCurrentCanvasData(state);

    const fontSizeRange = state.fontSizeRangeDict[imprintAreaCode];
    const defaultFontSize = state.canvasDict[imprintAreaKey].defaultFontSize;
    const textType = state.canvasDict[imprintAreaKey].newTextType;
    const fontSizeInRange =
      defaultFontSize < fontSizeRange.minFontSize
        ? fontSizeRange.minFontSize
        : defaultFontSize > fontSizeRange.maxFontSize
        ? fontSizeRange.maxFontSize
        : defaultFontSize;

    const fontList = state.fontDict[imprintAreaCode];
    const defaultFont = fontList[0];
    const minTemplateFontSize = Math.min(...templateElement.map((e) => e.fontSize));
    const defaultTemplateFont =
      templateElement && templateElement[0] && fontList.find((font) => font.fontCode === templateElement[0].fontCode);
    const isColorTopToMax = currentStudioItemType === studioItemType.screenPrintedDigital && isTopToMax;

    let defaultTextColor = defaultDigitalTextColor;

    if (currentStudioItemType === studioItemType.screenPrintedDigital) {
      const imprintColors = getImprintColors(state, imprintAreaKey);
      if (imprintColors && imprintColors.length > 0) {
        defaultTextColor = imprintColors[0];
      }
    }

    // screenPrintedDigital products has only one text color. If the text color has been changed, the new text will be the changed color.
    // The initialization of the text color from the shopping cart needs to use the default color.
    const color =
      currentStudioItemType === studioItemType.screenPrintedDigital && selectedTextColor
        ? selectedTextColor
        : (isColorTopToMax || maxColorCount === 1) &&
          selectedImage &&
          selectedImage[0] &&
          selectedImage[0].data &&
          selectedImage[0].data.colors &&
          selectedImage[0].data.colors[0]
        ? selectedImage[0].data.colors[0]
        : defaultTemplateFont
        ? templateElement[0].color
        : defaultTextColor;

    const additionalTextInfo = {
      fontFace: defaultTemplateFont ? defaultTemplateFont.fontFace : defaultFont.fontFace,
      fontCode: defaultTemplateFont ? defaultTemplateFont.fontCode : defaultFont.fontCode,
      fontFileName: defaultTemplateFont ? defaultTemplateFont.fontFileName : defaultFont.fontFileName,
      fontImgFileName: defaultTemplateFont ? defaultTemplateFont.fontImgFileName : defaultFont.fontImgFileName,
      zIndex: getImageLayerIndex(canvasData, false),
      color: color,
      text: text,
      maxFontSize: fontSizeRange.maxFontSize,
      fontSize: defaultTemplateFont ? minTemplateFontSize : fontSizeInRange,
      outlineThickness: defaultTemplateFont ? templateElement[0].outlineThickness : 0,
      outlineColor: defaultTemplateFont ? templateElement[0].outlineColor : defaultDigitalTextColor,
      textMode: textType ?? textMode.Single,
      isBold: defaultFont.hasBold,
      isItalic: defaultFont.hasItalic,
    };

    const textElement = elementLogics.createTextElement(additionalTextInfo, isNextgenUi);
    const scaleFactor = getCurrentScaleFactor(state, imprintAreaKey);
    const isHotStamped = mainSelectors.getCurrentHotStampedCheck(state);

    let colorImageUrl = '';

    if (isHotStamped) {
      colorImageUrl = getHotStampColorImageUrl(textElement.data.color.colorId);
    }

    const isDeboss = mainSelectors.getCurrentDebossCheck(state);

    addElementInternal(
      dispatch,
      imprintAreaKey,
      draggingArea,
      textElement,
      fontSizeRange,
      studioScale,
      vendorId,
      scaleFactor,
      false,
      isNextgenUi,
      isHotStamped,
      colorImageUrl,
      isDeboss,
      setEditing
    );
  };
};

export const addInitTextElementsFromCart = function (textDataDict, fontDict, fontSizeRangeDict) {
  return (dispatch) => {
    let textDict = {};
    Object.keys(textDataDict).forEach((imprintAreaKey) => {
      let textList = [];
      if (textDataDict[imprintAreaKey] && textDataDict[imprintAreaKey].length > 0) {
        textDataDict[imprintAreaKey].forEach((textData) => {
          let imprintAreaCode = imprintAreaKey.split('-')[0];
          let updatedTextElement = updateTextElement(
            fontDict[imprintAreaCode],
            fontSizeRangeDict[imprintAreaCode],
            textData
          );

          dispatch(textActions.addTextElement({ imprintAreaKey, textElement: updatedTextElement }));
          textList.push(updatedTextElement);
        });
      }
      textDict[imprintAreaKey] = textList;
    });
    dispatch(addInitTextElementsUI(textDict));
  };
};

const addInitTextElementsUI = function (textDict) {
  return (dispatch, getState) => {
    const state = getState();
    const status = mainSelectors.getStatus(state);
    const currentAction = getConfiguratorAction(status);
    const vendorId = mainSelectors.getVendorId(state);
    const currentStudioItemType = mainSelectors.getStudioItemType(state);
    const specialWords = mainSelectors.getSpecialSpellingWords(state);
    const { color: colorWord } = specialWords;
    const editScreenPrintedDigitalItem =
      currentAction === configuratorAction.edit && currentStudioItemType === studioItemType.screenPrintedDigital;
    if (textDict) {
      Object.keys(textDict).forEach((imprintAreaKey) => {
        let textList = textDict[imprintAreaKey] || [];
        const studioScale = getStudioScaleByKey(state, imprintAreaKey);
        const scaleFactor = getCurrentScaleFactor(state, imprintAreaKey);
        const draggingArea = getCanvasDraggingArea(state, imprintAreaKey);
        let imprintAreaCode = imprintAreaKey.split('-')[0];
        let fontSizeRange = state.fontSizeRangeDict[imprintAreaCode];

        const imprintProcessType = mainSelectors.getCurrentImprintProcessType(state, imprintAreaKey);
        const useImageColor = getHotStampedCheck(imprintProcessType);
        const useDeboss = getDebossCheck(imprintProcessType);

        textList.forEach((text) => {
          let defaultText = text.data.defaultText?.replace('Color', colorWord);
          let updatedText = { ui: text.ui, data: { ...text.data, defaultText } };
          let imageColorUrl = '';
          if (useImageColor) {
            imageColorUrl = getHotStampColorImageUrl(text.data.color.colorId);
          }

          addElementInternalFromCart(
            dispatch,
            imprintAreaKey,
            updatedText,
            fontSizeRange,
            studioScale,
            vendorId,
            scaleFactor,
            draggingArea,
            editScreenPrintedDigitalItem,
            useImageColor,
            imageColorUrl,
            useDeboss
          );
        });
      });
    }
  };
};

export const addInitTextElements = function (textDataDict) {
  return (dispatch, getState) => {
    const state = getState();
    const vendorId = mainSelectors.getVendorId(state);
    const specialWords = mainSelectors.getSpecialSpellingWords(state);
    const { color: colorWord } = specialWords;
    //let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    //let imprintAreaCode = imprintAreaKey.split('-')[0];

    if (textDataDict) {
      Object.keys(textDataDict).forEach((imprintAreaKey) => {
        let textDataList = textDataDict[imprintAreaKey] || [];
        const draggingArea = getCanvasDraggingArea(state, imprintAreaKey);
        const studioScale = getStudioScaleByKey(state, imprintAreaKey);
        const scaleFactor = getCurrentScaleFactor(state, imprintAreaKey);
        let imprintAreaCode = imprintAreaKey.split('-')[0];
        let fontSizeRange = state.fontSizeRangeDict[imprintAreaCode];

        const imprintProcessType = mainSelectors.getCurrentImprintProcessType(state, imprintAreaKey);
        const useImageColor = getHotStampedCheck(imprintProcessType);
        const useDeboss = getDebossCheck(imprintProcessType);

        textDataList.forEach((textData) => {
          let updatedTextElement = updateTextElement(state.fontDict[imprintAreaCode], fontSizeRange, textData);
          let imageColorUrl = '';
          if (useImageColor) {
            imageColorUrl = getHotStampColorImageUrl(updatedTextElement.data.color.colorId);
          }

          updatedTextElement.data.defaultText = updatedTextElement.data.defaultText?.replace('Color', colorWord);
          addElementInternal(
            dispatch,
            imprintAreaKey,
            draggingArea,
            updatedTextElement,
            fontSizeRange,
            studioScale,
            vendorId,
            scaleFactor,
            true,
            false,
            useImageColor,
            imageColorUrl,
            useDeboss
          );
        });
      });
    }
  };
};

export const changeElement = function ({
  increment,
  guid,
  noProcess = false,
  successCallback,
  errorCallback,
  pushToUndo = false,
  adjustSize = false,
  waiting = true,
}) {
  return (dispatch, getState) => {
    const state = getState();
    let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    const curTextElement = elementLogics.getElement(state.textDict, imprintAreaKey, guid);
    if (!curTextElement) {
      return;
    }
    const vendorId = mainSelectors.getVendorId(state);
    let draggingArea = getCanvasDraggingArea(state);
    let studioItemType = mainSelectors.getStudioItemType(state);
    const fontSizeRange = textSelectors.getFontSizeRange(state);
    const studioScale = getCurrentStudioScale(state);
    const scaleFactor = getCurrentScaleFactor(state, imprintAreaKey);

    let needUpdatePreview = false;

    if (increment.data.imprintText) {
      needUpdatePreview = true;
    }
    // merge front end increment
    let tmpElement = utils.deepMerge(curTextElement, increment);
    let text = tmpElement.data.imprintText || tmpElement.data.defaultText;

    const isHotStamped = mainSelectors.getCurrentHotStampedCheck(state);
    const isDeboss = mainSelectors.getCurrentDebossCheck(state);

    let colorImageUrl = '';
    if (isHotStamped) {
      colorImageUrl = getHotStampColorImageUrl(tmpElement.data.color.colorId);
    }

    if (waiting) {
      dispatch(mainActions.showWaitingCover());
    }

    elementLogics
      .getTextImage(
        tmpElement.ui.maxFontSize,
        text,
        tmpElement.data.fontFace,
        tmpElement.ui.fontFileName,
        tmpElement.data.isBold,
        tmpElement.data.isItalic,
        tmpElement.data.isUnderline,
        tmpElement.data.color.colorReference,
        tmpElement.data.horizonMultiAlign,
        tmpElement.data.outlineThickness,
        tmpElement.data.outlineColor ? tmpElement.data.outlineColor.colorReference : '',
        studioScale,
        vendorId,
        isHotStamped,
        colorImageUrl,
        isDeboss,
        scaleFactor,
        tmpElement.ui.guid
      )
      .then((res) => {
        if (!res || !res.data) {
          return;
        }

        // merge response increment
        const base64Image = res.data.base64Image;
        const maxWidth = res.data.maxWidth;
        const maxHeight = res.data.maxHeight;

        const minElementSize = getElementSizeByFontSize(
          tmpElement.ui.maxFontSize,
          res.data.maxWidth,
          res.data.maxHeight,
          fontSizeRange.minFontSize
        );

        let responseIncrement = {};
        responseIncrement.ui = {
          base64Image,
          maxWidth,
          maxHeight,
          minWidth: minElementSize.width,
          minHeight: minElementSize.height,
          marginLeft: res.data.marginLeft,
        };
        tmpElement = utils.deepMerge(tmpElement, responseIncrement);

        if (noProcess) {
          let element = tmpElement;
          dispatch(elementActions.changeElement({ imprintAreaKey, element }));
          if (pushToUndo) dispatch(pushToUndoList(constants.undoRedoType.ChangeTemplateOrEditElement));

          if (waiting) {
            if (needUpdatePreview) {
              dispatch(updateFullPreview());
            } else {
              dispatch(mainActions.hideWaitingCover());
            }
          }
        } else {
          // success callback
          const success = function (element) {
            successCallback && successCallback(element);

            dispatch(elementActions.changeElement({ imprintAreaKey, element }));
            if (pushToUndo) dispatch(pushToUndoList(constants.undoRedoType.ChangeTemplateOrEditElement));

            if (waiting) {
              if (needUpdatePreview) {
                dispatch(updateFullPreview());
              } else {
                dispatch(mainActions.hideWaitingCover());
              }
            }
          };

          // error callback
          const error = function (checkResult) {
            errorCallback && errorCallback(checkResult);
            if (!checkResult.canvasFit) {
              dispatch(mainActions.showMessageBox(constants.MESSAGE_ELEMENT_NOT_FIT));
            } else if (!checkResult.sideFit) {
              dispatch(mainActions.showMessageBox(constants.MESSAGE_ELEMENT_NOT_FIT));
            }
            if (waiting) {
              dispatch(mainActions.hideWaitingCover());
            }
          };

          // process the change to decide if we should update the store
          processChangedElement(draggingArea, tmpElement, { success, error }, fontSizeRange, adjustSize);
        }

        dispatch(calculateMaxAvailableFontSize({ guid: tmpElement.ui.guid, imprintAreaKey }));
      });
  };
};

export const changeTextColorForScreenPrinted =
  ({ formatkey, color }, callback) =>
  (dispatch, getState) => {
    const state = getState();

    const textList = state.textDict[formatkey];
    let increment = {};
    increment.data = {
      color: {
        cmyk: '',
        colorReference: color.colorReference,
        colorType: color.colorType,
        colorId: color.colorId,
        colorDescription: color.colorDescription,
      },
    };

    const textGuids = textList.map((text) => text.ui.guid);

    dispatch(changeElements(increment, textGuids, callback));
  };

export const changeElements = function (increment, guids, callback, pushMode = constants.pushToUndoListMode.None) {
  return (dispatch, getState) => {
    const state = getState();
    const vendorId = mainSelectors.getVendorId(state);
    let draggingArea = getCanvasDraggingArea(state);
    let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    const scaleFactor = getCurrentScaleFactor(state, imprintAreaKey);

    const curTextElements = guids.map((guid) => elementLogics.getElement(state.textDict, imprintAreaKey, guid));
    const studioScale = getCurrentStudioScale(state);
    // merge front end increment
    let tmpElements = curTextElements.map((curTextElement) => {
      const curIncrement = Object.assign({}, increment);
      const result = utils.deepMerge(curTextElement, curIncrement);
      return result;
    });

    const isHotStamped = mainSelectors.getCurrentHotStampedCheck(state);
    const isDeboss = mainSelectors.getCurrentDebossCheck(state);

    let promises = tmpElements.map((tmpElement) => {
      let text = tmpElement.data.imprintText || tmpElement.data.defaultText;

      let colorImageUrl = '';
      if (isHotStamped) {
        colorImageUrl = getHotStampColorImageUrl(tmpElement.data.color.colorId);
      }
      return elementLogics.getTextImage(
        tmpElement.ui.maxFontSize,
        text,
        tmpElement.data.fontFace,
        tmpElement.ui.fontFileName,
        tmpElement.data.isBold,
        tmpElement.data.isItalic,
        tmpElement.data.isUnderline,
        tmpElement.data.color.colorReference,
        tmpElement.data.horizonMultiAlign,
        tmpElement.data.outlineThickness,
        tmpElement.data.outlineColor ? tmpElement.data.outlineColor.colorReference : '',
        studioScale,
        vendorId,
        isHotStamped,
        colorImageUrl,
        isDeboss,
        scaleFactor
      );
    });

    const result = Promise.all(promises).then((resList) => {
      resList.forEach((res, index) => {
        let tmpElement = tmpElements[index];
        // merge response increment
        const base64Image = res.data.base64Image;
        const maxWidth = res.data.maxWidth;
        const maxHeight = res.data.maxHeight;
        let responseIncrement = {};
        responseIncrement.ui = { base64Image, maxWidth, maxHeight };
        tmpElement = utils.deepMerge(tmpElement, responseIncrement);

        // success callback
        const success = function (element) {
          dispatch(elementActions.changeElement({ imprintAreaKey, element }));
        };

        // error callback
        const error = function (checkResult) {
          if (!checkResult.canvasFit) {
            dispatch(mainActions.showMessageBox(constants.MESSAGE_ELEMENT_NOT_FIT));
          } else if (!checkResult.sideFit) {
            dispatch(mainActions.showMessageBox(constants.MESSAGE_ELEMENT_NOT_FIT));
          }
        };

        // process the change to decide if we should update the store
        processChangedElement(draggingArea, tmpElement, { success, error });
        if (pushMode === constants.pushToUndoListMode.UpdateTextElement)
          dispatch(updateUndoListRecord(imprintAreaKey, tmpElement, true));
      });

      if (pushMode === constants.pushToUndoListMode.AddNew)
        dispatch(pushToUndoList(constants.undoRedoType.ChangeTemplateOrEditElement, pushMode));

      return Promise.resolve();
    });

    if (callback) {
      result.then(() => callback());
    }
  };
};

// text nonDigital
const checkInitTextStyle = function (fontList, isBold, isItalic, fontFace) {
  const fontFaceList = [];
  fontList.forEach((font) => {
    if (font.fontFace === fontFace) {
      fontFaceList.push(font);
    }
  });
  let hasBTrueITrue = fontFaceList.some((font) => font.hasBold === true && font.hasItalic === true);
  let hasBTrueIFalse = fontFaceList.some((font) => font.hasBold === true && font.hasItalic === false);
  let hasBFalseITrue = fontFaceList.some((font) => font.hasBold === false && font.hasItalic === true);
  let hasBFalseIFalse = fontFaceList.some((font) => font.hasBold === false && font.hasItalic === false);
  if (fontFaceList.length === 1) {
    isBold = fontFaceList[0].hasBold;
    isItalic = fontFaceList[0].hasItalic;
  } else if (fontFaceList.length === 2) {
    if (hasBFalseIFalse) {
      isBold = false;
      isItalic = false;
    } else if (hasBTrueITrue && !hasBFalseIFalse) {
      // hasBold=0 hasItalic=1 + hasBold=1 hasItalic=1
      if (fontFaceList[0].hasBold === false) {
        isBold = false;
        isItalic = true;
      } else if (fontFaceList[0].hasItalic === false) {
        // hasBold=1 hasItalic=0 + hasBold=1 hasItalic=1
        isBold = true;
        isItalic = false;
      }
    } else if (!hasBFalseIFalse && !hasBTrueITrue) {
      // hasBold=1 hasItalic=0 + hasBold=0 hasItalic=1; init 0 1
      isBold = false;
      isItalic = true;
    }
  } else if (fontFaceList.length === 3) {
    if (!hasBFalseIFalse) {
      // init 1 1
      isBold = true;
      isItalic = true;
    } else if (!hasBTrueITrue || !hasBTrueIFalse || !hasBFalseITrue) {
      isBold = false;
      isItalic = false;
    }
  } else if (fontFaceList.length === 4) {
    isBold = false;
    isItalic = false;
  }
  return { isBold, isItalic };
};

export const changeNonDigitalFontFace = function (imprintAreaKey, selectedFont, guid, upsellItemId) {
  return (dispatch, getState) => {
    const state = getState();
    const { fontFace } = selectedFont;
    if (upsellItemId) {
      let upsellItem = state.upsells.find((upsell) => upsell.item.itemId === upsellItemId);
      if (upsellItem) {
        let upsellTextElement = elementLogics.getElement(upsellItem.textDict, imprintAreaKey, guid);
        if (upsellTextElement) {
          const { isBold, isItalic } = upsellTextElement.data;
          const upsellFontList = getCurrentUpsellFontList(state);
          let upsellTextStyle = checkInitTextStyle(upsellFontList, isBold, isItalic, fontFace);
          dispatch(
            changeUpsellFontFace({
              upsellImprintAreaKey: imprintAreaKey,
              fontFace,
              isBold: upsellTextStyle.isBold,
              isItalic: upsellTextStyle.isItalic,
              guid,
              upsellItemId,
            })
          );
          dispatch(
            changeCurrentUpsellFontCode(
              imprintAreaKey,
              fontFace,
              upsellTextStyle.isBold,
              upsellTextStyle.isItalic,
              guid,
              upsellItemId
            )
          );
        }
      }
    } else {
      const textElement = elementLogics.getElement(state.textDict, imprintAreaKey, guid);
      const { isBold, isItalic } = textElement.data;
      const fontList = textSelectors.getCurrentFontList(state);
      let textStyle = checkInitTextStyle(fontList, isBold, isItalic, fontFace);
      dispatch(
        textActions.changeNonDigitalFontFace({
          imprintAreaKey,
          fontFace,
          isBold: textStyle.isBold,
          isItalic: textStyle.isItalic,
          guid,
        })
      );
      dispatch(changeNonDigitalFontCode(imprintAreaKey, fontFace, textStyle.isBold, textStyle.isItalic, guid));
      dispatch(updateTextLineDict());
    }
  };
};

export const changeNonDigitalFontCode = function (imprintAreaKey, fontFace, isBold, isItalic, guid) {
  return (dispatch, getState) => {
    const state = getState();
    const fontList = textSelectors.getCurrentFontList(state);
    let selectedFontCode = '';
    fontList.forEach((font) => {
      if (font.fontFace === fontFace && font.hasBold === isBold && font.hasItalic === isItalic) {
        selectedFontCode = font.fontCode;
        return selectedFontCode;
      }
    });
    dispatch(textActions.changeNonDigitalFontCode({ imprintAreaKey, selectedFontCode, guid }));
    dispatch(updateTextLineDict());
  };
};

export const changeCurrentUpsellFontCode = function (
  upsellImprintAreaKey,
  fontFace,
  isBold,
  isItalic,
  guid,
  upsellItemId
) {
  return (dispatch, getState) => {
    const state = getState();
    const fontList = getCurrentUpsellFontList(state);
    let selectedFontCode = '';
    fontList.forEach((font) => {
      if (font.fontFace === fontFace && font.hasBold === isBold && font.hasItalic === isItalic) {
        selectedFontCode = font.fontCode;
        return selectedFontCode;
      }
    });
    dispatch(changeUpsellFontCode({ upsellImprintAreaKey, selectedFontCode, guid, upsellItemId }));
  };
};

export const changeNonDigitalTextStyle = function (imprintAreaKey, styleToChange, guid) {
  return (dispatch, getState) => {
    const state = getState();
    const imprintAreaCode = mainSelectors.getCurrentImprintAreaCode(state);
    const textElement = elementLogics.getElement(state.textDict, imprintAreaKey, guid);
    const { isBold, isItalic, fontFace } = textElement.data;
    const fontList = state.fontDict[imprintAreaCode];
    // check if the style is available
    let isAvailableStyle = true;
    let styleAvailable = checkStyleAvailable(fontList, styleToChange, { isBold, isItalic, fontFace, isAvailableStyle });
    if (styleAvailable.isAvailableStyle) {
      let increment = {};
      increment.data = { isBold, isItalic };
      if (styleToChange === constants.textStyleType.Bold) {
        if (isItalic !== styleAvailable.isItalic) {
          increment.data.isItalic = styleAvailable.isItalic;
        }
        increment.data.isBold = !isBold;
      } else if (styleToChange === constants.textStyleType.Italic) {
        if (isBold !== styleAvailable.isBold) {
          increment.data.isBold = styleAvailable.isBold;
        }
        increment.data.isItalic = !isItalic;
      }
      dispatch(textActions.changeNonDigitalTextStyle({ imprintAreaKey, increment, guid }));
      dispatch(
        changeNonDigitalFontCode(
          imprintAreaKey,
          textElement.data.fontFace,
          increment.data.isBold,
          increment.data.isItalic,
          guid
        )
      );
      dispatch(updateTextLineDict());
    } else {
      dispatch(mainActions.showMessageBox('The style you selected is not available'));
    }
  };
};

export const changeCurrentUpsellTextStyle = function (upsellImprintAreaKey, styleToChange, guid, upsellItemId) {
  return (dispatch, getState) => {
    const state = getState();
    let upsellItem = state.upsells.find((upsell) => upsell.item.itemId === upsellItemId);
    if (upsellItem) {
      let upsellTextElement = elementLogics.getElement(upsellItem.textDict, upsellImprintAreaKey, guid);
      if (upsellTextElement) {
        const { isBold, isItalic, fontFace } = upsellTextElement.data;
        const upsellFontList = getCurrentUpsellFontList(state);
        // check if the style is available
        let isAvailableStyle = true;
        let styleAvailable = checkStyleAvailable(upsellFontList, styleToChange, {
          isBold,
          isItalic,
          fontFace,
          isAvailableStyle,
        });
        if (styleAvailable.isAvailableStyle) {
          let increment = {};
          increment.data = { isBold, isItalic };
          if (styleToChange === constants.textStyleType.Bold) {
            if (isItalic !== styleAvailable.isItalic) {
              increment.data.isItalic = styleAvailable.isItalic;
            }
            increment.data.isBold = !isBold;
          } else if (styleToChange === constants.textStyleType.Italic) {
            if (isBold !== styleAvailable.isBold) {
              increment.data.isBold = styleAvailable.isBold;
            }
            increment.data.isItalic = !isItalic;
          }
          dispatch(changeUpsellTextStyle({ upsellImprintAreaKey, increment, guid, upsellItemId }));
          dispatch(
            changeCurrentUpsellFontCode(
              upsellImprintAreaKey,
              upsellTextElement.data.fontFace,
              increment.data.isBold,
              increment.data.isItalic,
              guid,
              upsellItemId
            )
          );
        } else {
          dispatch(mainActions.showMessageBox('The style you selected is not available'));
        }
      }
    }
  };
};

export const changeNonDigitalText = function (imprintAreaKey, imprintText, guid, upsellItemId) {
  return (dispatch) => {
    if (upsellItemId) {
      dispatch(changeUpsellText({ upsellImprintAreaKey: imprintAreaKey, imprintText, guid, upsellItemId }));
    } else {
      dispatch(textActions.changeNonDigitalText({ imprintAreaKey, imprintText, guid }));
      dispatch(updateTextLineDict());
    }
  };
};

export const changeSuperUserText = function (superUserTextDict) {
  return (dispatch, getState) => {
    const state = getState();
    let imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    dispatch(textActions.changeSuperUserText({ imprintAreaKey, superUserTextDict }));
  };
};

export const applyStyleToAllNonDigitalText = function (imprintAreaKey, guid) {
  return (dispatch, getState) => {
    const state = getState();
    const textList = state.textDict[imprintAreaKey];
    const textElement = elementLogics.getElement(state.textDict, imprintAreaKey, guid);
    const { fontFace, fontCode, fontSizeText, isBold, isItalic } = textElement.data;
    const increment = {
      data: { fontFace, fontCode, fontSizeText, isBold, isItalic },
    };
    const otherTextList = textList.filter((element) => element.ui.guid !== guid);
    if (otherTextList.length > 0) {
      const guids = otherTextList.map((element) => element.ui.guid);
      dispatch(textActions.changeStyleToAllNonDigitalText({ imprintAreaKey, increment, guids }));
      dispatch(updateTextLineDict());
    }

    dispatch(invalidCharactersRetrieval());
    dispatch(updateNonDigitalFullPreview({ needUpdatePreview: true }));
  };
};

export const applyStyleToAllUpsellText = function (upsellImprintAreaKey, guid, upsellItemId) {
  return (dispatch, getState) => {
    const state = getState();
    let upsellItem = state.upsells.find((upsell) => upsell.item.itemId === upsellItemId);
    if (upsellItem) {
      const textList = upsellItem.textDict[upsellImprintAreaKey];
      let upsellTextElement = elementLogics.getElement(upsellItem.textDict, upsellImprintAreaKey, guid);
      if (upsellTextElement) {
        const { fontFace, fontCode, fontSizeText, isBold, isItalic } = upsellTextElement.data;
        const increment = {
          data: { fontFace, fontCode, fontSizeText, isBold, isItalic },
        };
        const otherTextList = textList.filter((element) => element.ui.guid !== guid);
        if (otherTextList.length > 0) {
          const guids = otherTextList.map((element) => element.ui.guid);
          dispatch(changeStyleToAllUpsellText({ upsellImprintAreaKey, increment, guids, upsellItemId }));
        }

        dispatch(invalidCharactersRetrieval({ fromUpsellText: true }));
        dispatch(updateUpsellImprintSizing({ needUpdatePreview: true }));
      }
    }
  };
};

// remember text: copy textDict data to textLineDict data
export const updateTextLineDict = function () {
  return (dispatch, getState) => {
    const state = getState();
    const imprintAreaCode = mainSelectors.getCurrentImprintAreaCode(state);
    const nonDigitalTextDataList = textSelectors.getCurrentNonDigitalTextDataList(state);
    dispatch(textActions.changeNonDigitalTextLine({ imprintAreaCode, nonDigitalTextDataList }));
  };
};

export const getBIAvailability = function (currentElement, fontList) {
  const availability = { boldEnabled: true, italicEnabled: true };
  const selectedFontFace = currentElement.data.fontFace;
  const fontFaceList = [];
  fontList.forEach((font) => {
    if (font.fontFace === selectedFontFace) {
      fontFaceList.push(font);
    }
  });
  let hasBTrueITrue = fontFaceList.some((font) => font.hasBold === true && font.hasItalic === true);
  let hasBTrueIFalse = fontFaceList.some((font) => font.hasBold === true && font.hasItalic === false);
  let hasBFalseITrue = fontFaceList.some((font) => font.hasBold === false && font.hasItalic === true);
  let hasBFalseIFalse = fontFaceList.some((font) => font.hasBold === false && font.hasItalic === false);
  if (fontFaceList.length === 1) {
    if (fontFaceList[0].hasBold === true) {
      availability.boldEnabled = textStyleIconStatus.ActivatedDisabled;
    } else {
      availability.boldEnabled = textStyleIconStatus.Disabled;
    }
    if (fontFaceList[0].hasItalic === true) {
      availability.italicEnabled = textStyleIconStatus.ActivatedDisabled;
    } else {
      availability.italicEnabled = textStyleIconStatus.Disabled;
    }
  } else if (fontFaceList.length === 2) {
    if (hasBFalseIFalse) {
      if (hasBFalseITrue) {
        // hasBold=0 hasItalic=0 + hasBold=0 hasItalic=1
        availability.boldEnabled = textStyleIconStatus.Disabled;
        availability.italicEnabled = textStyleIconStatus.Unactivated;
      } else if (hasBTrueIFalse) {
        // hasBold=0 hasItalic=0 + hasBold=1 hasItalic=0
        availability.boldEnabled = textStyleIconStatus.Unactivated;
        availability.italicEnabled = textStyleIconStatus.Disabled;
      }
    } else if (hasBTrueITrue) {
      if (hasBFalseITrue) {
        // hasBold=1 hasItalic=1 + hasBold=0 hasItalic=1
        availability.boldEnabled = textStyleIconStatus.Unactivated;
        availability.italicEnabled = textStyleIconStatus.ActivatedDisabled;
      } else if (hasBTrueIFalse) {
        // hasBold=1 hasItalic=1 + hasBold=1 hasItalic=0
        availability.boldEnabled = textStyleIconStatus.ActivatedDisabled;
        availability.italicEnabled = textStyleIconStatus.Unactivated;
      }
    } else {
      availability.boldEnabled = textStyleIconStatus.Unactivated;
      availability.italicEnabled = textStyleIconStatus.Unactivated;
    }
  } else if (fontFaceList.length === 3) {
    if (!hasBTrueIFalse && currentElement.data.isItalic === false) {
      // if isitalic is false, the bold button is forced not to be selected, otherwise the bold button can be selected or not
      availability.boldEnabled = textStyleIconStatus.Disabled;
      availability.italicEnabled = textStyleIconStatus.Unactivated;
    } else if (!hasBFalseITrue && currentElement.data.isBold === false) {
      availability.boldEnabled = textStyleIconStatus.Unactivated;
      availability.italicEnabled = textStyleIconStatus.Disabled;
    } else {
      availability.boldEnabled = textStyleIconStatus.Unactivated;
      availability.italicEnabled = textStyleIconStatus.Unactivated;
    }
  } else if (fontFaceList.length === 4) {
    availability.boldEnabled = textStyleIconStatus.Unactivated;
    availability.italicEnabled = textStyleIconStatus.Unactivated;
  }
  return availability;
};

export const getNonDigitalTextPanelData = function (nonDigitalTextDataList) {
  const textPanelData = [];
  nonDigitalTextDataList.forEach((text) => {
    let textData = Object.assign(
      {},
      {
        color: text.color,
        fontSizeText: text.fontSizeText,
        fontFace: text.fontFace,
        imprintText: text.imprintText,
        isBold: text.isBold,
        isItalic: text.isItalic,
      }
    );
    textPanelData.push(textData);
  });
  return textPanelData;
};

export const getLiteTextPanelData = function (nonDigitalTextDataList) {
  const textPanelData = [];
  nonDigitalTextDataList.forEach((text) => {
    let textData = Object.assign(
      {},
      {
        color: text.color,
        imprintText: text.imprintText,
      }
    );
    textPanelData.push(textData);
  });
  return textPanelData;
};

export const getThicknessLable = (thicknessValue) => {
  const thickness = outlineThicknessList.find((x) => x.value === thicknessValue);
  return thickness ? thickness.label : '';
};

export const addNewText = () => (dispatch, getState) => {
  const state = getState();
  const canvasKey = mainSelectors.getCurrentImprintAreaKey(state);
  dispatch(unSelectAllText({ canvasKey }));
  const selectedTemplate = getSelectedTemplate(state);
  dispatch(showWaitingCover());
  const defaultText = getDefaultText(state);
  dispatch(changeTemplateElement(selectedTemplate, false, defaultText));
};

const updateImageListColor = (params) => (dispatch, getState) => {
  const { artList, formatkey, newColor, oldColor, newColors, changeAll } = params;
  const state = getState();

  const changingElement = getSingleSelectedElement(state);
  let callbackIsCalled = false;
  const callback = () => {
    params.callback && params.callback();
  };

  const logoSavedArtList = artList.filter(
    (userimg) =>
      userimg.data && (userimg.data.type === userImageType.UploadLogo || userimg.data.type === userImageType.SavedArt)
  );

  //const changeAll = maxColorCount === 1 || (colorsInUse.length >= maxColorCount && !newColorIsInUse);

  if (logoSavedArtList && logoSavedArtList.length > 0) {
    logoSavedArtList.forEach((userimg) => {
      const needChangeColor = userimg.data && userimg.data.colors.find((color) => color.colorId === oldColor.colorId);
      if (needChangeColor) {
        let newColorList = [];

        if (changingElement && userimg.ui.guid === changingElement.ui.guid) {
          if (changeAll) {
            newColorList = newColors.map((color) => {
              if (color.colorId === oldColor.colorId) {
                return newColor;
              } else return color;
            });
          } else {
            newColorList = newColors;
          }
        } else {
          newColorList = userimg.data.colors.map((color) => {
            if (color.colorId === oldColor.colorId) {
              return newColor;
            } else return color;
          });
        }

        if (userimg === logoSavedArtList[logoSavedArtList.length - 1]) {
          //only callback on last item
          changeLogoColor({
            ...params,
            newColors: newColorList,
            dispatch,
            callback,
            selectedLogo: userimg,
            isChangingColor: true,
          });
          callbackIsCalled = true;
        } else {
          changeLogoColor({
            ...params,
            newColors: newColorList,
            dispatch,
            callback: null,
            selectedLogo: userimg,
            isChangingColor: true,
          });
        }
      }
    });
  }

  const otherArtList = artList.filter(
    (userimg) =>
      userimg.data && userimg.data.type !== userImageType.UploadLogo && userimg.data.type !== userImageType.SavedArt
  );
  if (otherArtList && otherArtList.length > 0) {
    otherArtList.forEach((userimg) => {
      const needChangeColor = userimg.data && userimg.data.colors.find((color) => color.colorId === oldColor.colorId);
      if (needChangeColor) {
        dispatch(changeArtColor({ canvasKey: formatkey, guid: userimg.ui.guid, colors: [newColor], oldColor }));
      }
    });
  }
  if (!callbackIsCalled) callback();
};

export const setNewFreeColorAfterColorChanged =
  ({ oldColor, newColor }) =>
  (dispatch, getState) => {
    const state = getState();
    const colorsInUse = getAllColorsInUse(state);
    const freeColor = getFreeColor(state);
    if (
      freeColor &&
      freeColor.colorId === oldColor.colorId &&
      colorsInUse.every((c) => c.colorId !== freeColor.colorId)
    ) {
      dispatch(setFreeColor(newColor));
    }
  };

export const colorChangeCompleted = (oldColor, newColor) => (dispatch, getState) => {
  dispatch(pushToUndoList(constants.undoRedoType.ChangeTemplateOrEditElement));
  dispatch(updateFullPreview());
  dispatch(setNewFreeColorAfterColorChanged({ oldColor, newColor }));
};

export const screenPrintedDigitalColorChange =
  ({ formatkey, oldColor, newColor, newColors }) =>
  (dispatch, getState) => {
    const state = getState();

    const { elements: changingElements, changeAll } = getColorChangeElements(oldColor, newColor, state);
    const changeTextColor = () => {
      const hasTextChange = changingElements.some((element) => element.data.imprintText || element.data.defaultText);

      const callback = () => {
        dispatch(colorChangeCompleted(oldColor, newColor));
      };

      if (hasTextChange) {
        dispatch(changeTextColorForScreenPrinted({ formatkey, color: newColor }, callback));
      } else {
        callback();
      }
    };

    const artList = changingElements.filter(
      (element) => element.data.imprintText === undefined && element.data.defaultText === undefined
    );

    if (artList && artList.length > 0) {
      const params = {
        artList,
        newColor,
        oldColor,
        newColors,
        formatkey,
        canvasKey: formatkey,
        vendorId: mainSelectors.getVendorId(state),
        imprintColorList: getImprintColors(state, formatkey),
        changeAll,
        callback: changeTextColor,
      };
      dispatch(showWaitingCover());
      dispatch(updateImageListColor(params));
    } else {
      changeTextColor();
    }
  };
export const setBackupElements = () => (dispatch, getState) => {
  const state = getState();
  const currentImprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
  const texts = state.textDict[currentImprintAreaKey] || [];
  const images = state.imageDict[currentImprintAreaKey] || [];
  dispatch(setBackupElementsAction({ texts, images }));
};

export const restoreBackupElements =
  ({ callback } = {}) =>
  (dispatch, getState) => {
    const state = getState();
    const backupElements = state.nextgenUi.backupElements;
    const imprintAreaKey = mainSelectors.getCurrentImprintAreaKey(state);
    dispatch(setImageListByImprintAreaKeyAction({ imprintAreaKey, imageList: backupElements.image }));
    dispatch(setTextListByImprintAreaKeyAction({ imprintAreaKey, textList: backupElements.text }));
    dispatch(updateFullPreview());
    callback && callback();
  };

export const goToEditTextColor = () => (dispatch, getState) => {
  dispatch(backupTextColor());
  dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.TextColorPanel } }));
};

export const backupTextColor = () => (dispatch, getState) => {
  const state = getState();
  const studioItemType = mainSelectors.getStudioItemType(state);
  const selectedText = textSelectors.getSelectedTextElement(state);
  const selectedBatchText = getBatchSelectedTextList(state);

  const batchMode = selectedBatchText && selectedBatchText.length > 1;

  if (studioItemType === studioItemTypeEnum.screenPrintedDigital) {
    dispatch(setBackupElements());
  } else if (studioItemType === studioItemTypeEnum.digital) {
    if (batchMode) {
      selectedBatchText.forEach((text) => {
        dispatch(setBackupTextColor({ textGuid: text.ui.guid, textColor: text.data.color }));
      });
    } else {
      dispatch(setBackupTextColor({ textGuid: selectedText.ui.guid, textColor: selectedText.data.color }));
    }
  }
};

export const goToEditTextOutline = () => (dispatch, getState) => {
  dispatch(backupTextOutlineColor());
  dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.TextOutlineColorPanel } }));
};

export const backupTextOutlineColor = () => (dispatch, getState) => {
  const state = getState();
  const studioItemType = mainSelectors.getStudioItemType(state);
  if (studioItemType !== studioItemTypeEnum.digital) {
    return;
  }
  const selectedText = textSelectors.getSelectedTextElement(state);
  const selectedBatchText = getBatchSelectedTextList(state);

  const batchMode = selectedBatchText && selectedBatchText.length > 1;

  if (batchMode) {
    selectedBatchText.forEach((text) => {
      dispatch(setBackupTextOutlineColor({ textGuid: text.ui.guid, textOutlineColor: text.data.outlineColor }));
    });
  } else {
    dispatch(
      setBackupTextOutlineColor({ textGuid: selectedText.ui.guid, textOutlineColor: selectedText.data.outlineColor })
    );
  }
};

export const restoreTextBackupColor =
  ({ callback }) =>
  (dispatch, getState) => {
    const state = getState();
    const studioItemType = mainSelectors.getStudioItemType(state);
    const selectedText = textSelectors.getSelectedTextElement(state);
    const selectedBatchText = getBatchSelectedTextList(state);

    const batchMode = selectedBatchText && selectedBatchText.length > 1;

    if (studioItemType === studioItemTypeEnum.screenPrintedDigital) {
      dispatch(restoreBackupElements());
    } else if (studioItemType === studioItemTypeEnum.digital) {
      if (batchMode) {
        selectedBatchText.forEach((text) => {
          const backupColor = getBackupTextColor(state, text.ui.guid);
          dispatch(
            changeColor(
              text.ui.guid,
              backupColor.cmyk,
              backupColor.colorId,
              backupColor.colorReference,
              backupColor.colorType,
              backupColor.colorDescription
            )
          );
        });
      } else {
        const backupColor = getBackupTextColor(state, selectedText.ui.guid);
        dispatch(
          changeColor(
            selectedText.ui.guid,
            backupColor.cmyk,
            backupColor.colorId,
            backupColor.colorReference,
            backupColor.colorType,
            backupColor.colorDescription
          )
        );
      }
    }

    callback && callback();
  };

export const restoreTextOulineBackupColor = () => (dispatch, getState) => {
  const state = getState();
  const studioItemType = mainSelectors.getStudioItemType(state);
  if (studioItemType !== studioItemTypeEnum.digital) {
    return;
  }
  const selectedText = textSelectors.getSelectedTextElement(state);
  const selectedBatchText = getBatchSelectedTextList(state);

  const batchMode = selectedBatchText && selectedBatchText.length > 1;

  if (batchMode) {
    selectedBatchText.forEach((text) => {
      const backupOutlineColor = getBackupTextOutlineColor(state, text.ui.guid);
      dispatch(
        changeOutlineColor(
          text.ui.guid,
          backupOutlineColor.cmyk,
          backupOutlineColor.colorId,
          backupOutlineColor.colorReference,
          backupOutlineColor.colorType,
          backupOutlineColor.colorDescription
        )
      );
    });
  } else {
    const backupOutlineColor = getBackupTextOutlineColor(state, selectedText.ui.guid);
    dispatch(
      changeOutlineColor(
        selectedText.ui.guid,
        backupOutlineColor.cmyk,
        backupOutlineColor.colorId,
        backupOutlineColor.colorReference,
        backupOutlineColor.colorType,
        backupOutlineColor.colorDescription
      )
    );
  }
};

export const getBatchTextOutlineRect = (batchTexts) => {
  let rotatedTextPoints = [];
  batchTexts.forEach((text) => {
    var rotateText = rotateCanvasElement(text);
    var rotatePoints = rotateText.rotatedRectPoints;
    rotatedTextPoints = rotatedTextPoints.concat(rotatePoints);
  });

  const minX = Math.min(...rotatedTextPoints.map((point) => point.x));
  const minY = Math.min(...rotatedTextPoints.map((point) => point.y));
  const maxX = Math.max(...rotatedTextPoints.map((point) => point.x));
  const maxY = Math.max(...rotatedTextPoints.map((point) => point.y));

  return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
};

export const getInputIsInDraggingArea = (props) => {
  const { editingText, draggingArea, scale, inputSize } = props;

  const inputRect = {
    x: editingText.data.x,
    y: editingText.data.y,
    width: inputSize.width / scale,
    height: inputSize.height / scale,
  };

  const inputRotatedPoints = getRotatedRectPoints(inputRect, editingText.data.direction);

  const buffWidth = draggingArea.width * 0.1;
  const buffHeight = draggingArea.height * 0.1;

  let isAllInRange = true;
  inputRotatedPoints.forEach((point) => {
    const isInDraggingArea =
      point.x >= draggingArea.x - buffWidth &&
      point.x <= draggingArea.x + draggingArea.width + buffWidth &&
      point.y >= draggingArea.y - buffHeight &&
      point.y <= draggingArea.y + draggingArea.height + buffHeight;

    if (!isInDraggingArea) {
      isAllInRange = false;
    }
  });

  return isAllInRange;
};
